export const allCardsEvo = [
  "Aerin, Forever Brilliant Evolved",
  "Flower Fox Evolved",
  "Wellspring Elf Princess Evolved",
  "Coldhearted Dark Elf Evolved",
  "Armelize, Opulent Strategist Evolved",
  "Assault Knight Evolved",
  "Axe Pirate Evolved",
  "Calculating Captain Evolved",
  "Chrono Witch Evolved",
  "Levi, Wizard of Ages Evolved",
  "Witching Moggy Evolved",
  "Elina, Winged Evangelist Evolved",
  "Blade Mage Evolved",
  "Ignis Dragon Evolved",
  "Noir & Blanc, Brothers Evolved",
  "Coral Spirit Evolved",
  "Hailwyrm Evolved",
  "Dark Emperor Evolved",
  "Suzy, Hexcaster Evolved",
  "Scarlet Vampire Evolved",
  "Thunderbolt Fiend Evolved",
  "Holy Saber Evolved",
  "Sacred Lion Evolved",
  "Carmia, Miracle Optimist Evolved",
  "Holy Kitty Evolved",
  "Goblin Leader Evolved",
  "Oguri Cap [Surging Beast] Evolved",
  "Shizuru & Rino Evolved",
  "Misogi, Mimi & Kyoka Evolved",
  "Akino & Saren Evolved",
  "Lyelth, Immaculate Idol Evolved",
  "Cleaver Cat Evolved",
  "Elven Farmhand Evolved",
  "Bladebunny Evolved",
  "Galdr, Heroic Headmaster Evolved",
  "Agile Twinblader Evolved",
  "Tony, Plucky Polliwog Evolved",
  "Kitty Sergeant Evolved",
  "Anne, Brilliant Mage Evolved",
  "Grea, Crimson Promise Evolved",
  "Gruinne, Leonardian Provost Evolved",
  "Wolf Whisperer Evolved",
  "Lilium, the Witchwyrm Evolved",
  "Grand Slam Tamer Evolved",
  "Dragonborn Striker Evolved",
  "Ipupiara Evolved",
  "Cornelius, the Corpse King Evolved",
  "Arka, Sin Spinner Evolved",
  "Mach-Speed Maron Evolved",
  "Bonebreaker Bladesman Evolved",
  "Verdilia, Rogue Professor Evolved",
  "Wilbert, Desolate Paladin Evolved",
  "Lou, Lady-in-Training Evolved",
  "Pureflame Lady Evolved",
  "Zlatorog Evolved",
  "Lucius, Travelled Trainer Evolved",
  "Princess Knight Evolved",
  "Krulle, Heir to Unkilling Evolved",
  "Windbloom Sylph Evolved",
  "Supplicant of Unkilling Evolved",
  "Bearer of the Fairy Blade Evolved",
  "Sinciro, Heir to Usurpation Evolved",
  "Congregant of Usurpation Evolved",
  "Peppy Scout Evolved",
  "Comrade of the Swordmaster Evolved",
  "Velharia, Heir to Truth Evolved",
  "Axia, Heir to Destruction Evolved",
  "Raio, Elimination Manifest Evolved",
  "Congregant of Truth Evolved",
  "Devotee of Destruction Evolved",
  "Azurifrit, Heir to Disdain Evolved",
  "Spoiled Mermanager Evolved",
  "Supplicant of Disdain Evolved",
  "Snowstorm Dragonewt Evolved",
  "Rulenye & Valnareik Evolved",
  "Sham-Nacha, Heir to Entwining Evolved",
  "Congregant of Entwining Evolved",
  "Spirited Gravekeeper Evolved",
  "Ephemeral Demon Princess Evolved",
  "Himeka, Heir to Repose Evolved",
  "Congregant of Repose Evolved",
  "Supplicant of Repose Evolved",
  "Knight of the Holy Order Evolved",
  "Mjerrabaine, Great Manifest Evolved",
  "Dogged One Evolved",
  "Apostle of Voracity Evolved",
  "Magachiyo, Barbed Convict Evolved",
  "Verdant Lieutenant Evolved",
  "Budding Initiate Evolved",
  "Beast Lancer Evolved",
  "Barbaros, Briny Convict Evolved",
  "Gildaria, Anathema of Peace Evolved",
  "Warden of Honor Evolved",
  "Storm-Wracked First Mate Evolved",
  "Felpurr Maid Evolved",
  "Sephie, Depraved Convict Evolved",
  "Obsessive Scholar Evolved",
  "Devoted Researcher Evolved",
  "Electrokitty Evolved",
  "Drazael, Ravening Enforcer Evolved",
  "Scorched-Earth Tyrant Evolved",
  "Hotheaded Marauder Evolved",
  "Dancing Crab Evolved",
  "Garodeth, Insurgent Convict Evolved",
  "Abyssal Colonel Evolved",
  "Underworld Lieutenant Evolved",
  "Vicious Blitzer Evolved",
  "Uneriel, Winged Enforcer Evolved",
  "Warden of the Wings Evolved",
  "Agent of the Commandments Evolved",
  "Sacred Tiger Evolved",
  "Cutthroat, Discord Convict Evolved",
  "Zerael, Regent of Vicissitude ADVANCED",
  "Smeltwork Bodyguard Evolved",
  "Kokkoro Evolved",
  "Shiori Evolved",
  "Rino Evolved",
  "Lima Evolved",
  "Pecorine Evolved",
  "Jun Evolved",
  "Tomo Evolved",
  "Tamaki Evolved",
  "Karyl Evolved",
  "Maho Evolved",
  "Kyoka Evolved",
  "Yuki Evolved",
  "Sheffy Evolved",
  "Kaya Evolved",
  "Inori Evolved",
  "Mifuyu Evolved",
  "Illya Evolved",
  "Shinobu Evolved",
  "Yori Evolved",
  "Misaki Evolved",
  "Saren Evolved",
  "Yui Evolved",
  "Chika Evolved",
  "Mimi Evolved",
  "Omniscient Kaiser Evolved",
  "Ameth Evolved",
  "Kasumi Evolved",
  "Rolo Rone, Verdant Purifier Evolved",
  "Verdant Authority Caretaker Evolved",
  "Verdant City Pugilist Evolved",
  "Blossoming Lunerian Evolved",
  "Verdant Law Supplicant Evolved",
  "Shinra, All-Discerning Evolved",
  "Bird's-Eye Investigator Evolved",
  "Cold Case Analyst Evolved",
  "Blind Spot Surveyor Evolved",
  "Monika, Cloudhall Admiral Evolved",
  "Mana, Sterling Luster Evolved",
  "Bejeweled Supermodel Evolved",
  "Bejeweled Advisor Evolved",
  "Bejeweled Bouncer Evolved",
  "Carbuncle of Mysteria Evolved",
  "El, Destructive Dragon Evolved",
  "Dragon-Eyed Secretary Evolved",
  "Neon-Tailed Prefect Evolved",
  "Ian, Dragon Buster Evolved",
  "Lightning-Clawed Loafer Evolved",
  "Ilze & Urze, Centennial Reapers Evolved",
  "Vania, Crimson Majesty Evolved",
  "Covetous Serpent Evolved",
  "Exhumation Crow Evolved",
  "Gnawing Rat Evolved",
  "Beryl, Dreameater Evolved",
  "Seishiro, Admonishing Faith Evolved",
  "Conferrer of Vows Evolved",
  "Deliverer of Punishment Evolved",
  "Lorena, Iron-Willed Priest Evolved",
  "Votary of Contemplation Evolved",
  "Saito, Mao Ward Officer Evolved",
  "Stunfist Assassin Evolved",
  "Cyberglasses Criminal Evolved",
  "Grand Archer Selwyn Evolved",
  "Navalgazer Dragon Evolved",
  "Orchis, Resolute Puppet Evolved",
  "Paula, Gentle Warmth Evolved",
  "Fortuna Regina Evolved",
  "Silvernail Markswoman Evolved",
  "Vania, Kind Queen Evolved",
  "Ceryneian Lighthind Evolved",
  "SugarSugar☆Mi〜n Evolved",
  "Celia, Hope's Strategist Evolved",
  "King of Knights, Alfred Evolved",
  "Soul Saver Dragon Evolved",
  "Blazing Flare Dragon Evolved",
  "Embodiment of Victory, Aleph Evolved",
  "Garyu, Supreme Dragonkin Evolved",
  "Lævateinn Dragon, Attack Form Evolved",
  "Slaughtering Dragonewt Evolved",
  "Virtuous Lindworm Evolved",
  "Barking Manticore Evolved",
  "Daria, Dimensional Witch Evolved",
  "Mysterian Whitewyrm Evolved",
  "A Super Successful Event! Evolved",
  "At the End of the Day Evolved",
  "Forth! Into the Great Age of Agriculture! Evolved",
  "Harbinger of the Night Evolved",
  "Hungry for a Miracle Evolved",
  "Workshop! Farmers for a Day! Evolved",
  "Marlone, Light of Balance Evolved",
  "Blue Storm Supreme Dragon, Glory Maelstrom Evolved",
  "Albert, Levin Saber Evolved",
  "Wingy, Chirpy Gemstone Evolved",
  "Unicorn Dancer Unica Evolved",
  "Spawn of the Abyss Evolved",
  "Mithra, Daybreak Deity Evolved",
  "Colette, Holy Gunner Evolved",
  "Slade, Blossoming Wolf Evolved",
  "Sammy, Wizard's Apprentice Evolved",
  "Ladica, Verdant Claw Evolved",
  "Lococo, Little Puppeteer Evolved",
  "Beastfolk Harvester Evolved",
  "Blossom Treant Evolved",
  "Mistolina & Bayleon Evolved",
  "Frenzied Corpsmaster Evolved",
  "Valhorean Dealer Evolved",
  "Fox Lancer Evolved",
  "Isabelle, Intrepid Mage Evolved",
  "Tetra, Serene Sapphire Evolved",
  "Marie, Flowery Magician Evolved",
  "Awakened Robot Evolved",
  "Disrestan, Ocean Harbinger Evolved",
  "Djeana, the Stouthearted Evolved",
  "Forestclaw Sentinel Evolved",
  "Shark Warrior Evolved",
  "Urias, Final Vampire Evolved",
  "Aenea, Creative Amethyst Evolved",
  "Amy, Psychopomp Guide Evolved",
  "Rouge Vampire Evolved",
  "Yuwan, Dimensional Avenger Evolved",
  "Marlone, Peace Advocate Evolved",
  "Aerial Craft Evolved",
  "Steelwing Evolved",
  "Maisha, Purgation's Vessel Evolved",
  "Hoverboard Mercenary Evolved",
  "Relic Goddess ADVANCED",
  "Anastasia [Seize the Light] Evolved",
  "Riina Tada [Wannabe Legend] Evolved",
  "Hinako Kita [True Dream] Evolved",
  "Mio Honda [Cinderella Girl] Evolved",
  "Airi Totoki [Cinderella Girl] Evolved",
  "Mayu Sakuma [Love-Laden Gift] Evolved",
  "Chieri Ogata [Happiness Tune] Evolved",
  "Sae Kobayakawa [Dancing Flowers] Evolved",
  "Hiromi Seki [Twinkle in My Eye] Evolved",
  "Fumika Sagisawa [Cinderella Girl] Evolved",
  "Yui Ohtsuki [Lollipop Darling] Evolved",
  "Hotaru Shiragiku [Unbreakable] Evolved",
  "Nono Morikubo [individuals] Evolved",
  "Chitose Kurosaki [Memento Mori] Evolved",
  "Natsuki Kimura [Scarlet Love Song] Evolved",
  "Nana Abe [Cinderella Girl] Evolved",
  "Kako Takafuji [Lady Luck] Evolved",
  "Kotoka Saionji [Pure Euphoria] Evolved",
  "Aria, Lady of the Woods Evolved",
  "Glade, Fragrantwood Ward Evolved",
  "Aerin, Crystalian Frostward Evolved",
  "Fairy Tamer Evolved",
  "Amelia, Silver Captain Evolved",
  "Zirconia, Ironcrown Ward Evolved",
  "Luminous Commander Evolved",
  "Flashstep Quickblader Evolved",
  "Lilanthim, Anathema of Edacity Evolved",
  "Zizdvend, Fate's Arbiter Evolved",
  "Edelweiss, Sagelight Ward Evolved",
  "Penelope, Potions Prodigy Evolved",
  "Starry-Eyed Penguin Wizard Evolved",
  "Burnite, Anathema of Flame Evolved",
  "Nirle, Draconic Prodigy Evolved",
  "Liu Feng, Goldennote Ward Evolved",
  "Eyfa, Windrider Evolved",
  "Little Dragon Nanny Evolved",
  "Aragavy, Eternal Hunter Evolved",
  "Mukan, Shadowcrypt Ward Evolved",
  "Orthrus, Hellhound Blader Evolved",
  "Vlad, Impaler Evolved",
  "Rodeo, Anathema of Judgment Evolved",
  "Ronavero, Darkhaven Ward Evolved",
  "Angelic Prism Priestess Evolved",
  "Ironfist Priest Evolved",
  "Olivia, Heroic Dark Angel Evolved",
  "Phildau, Lionheart Ward Evolved",
  "Apollo, Heaven's Envoy Evolved",
  "Amataz, Reverse Blader Evolved",
  "Piercye, Queen of Frost Evolved",
  "Inauspicious Puppeteer Evolved",
  "Cryptid Keeper Evolved",
  "Hermit of Unkilling Evolved",
  "Kagemitsu, Lost Samurai Evolved",
  "Arsène Lupin Evolved",
  "Adherent of Hollowness Evolved",
  "Penguin Guardian Evolved",
  "Lishenna, Melodious Destruction Evolved",
  "Noble Shikigami ADVANCED",
  "Acid Golem Evolved",
  "Adherent of Elimination Evolved",
  "Scroll Wizard Evolved",
  "Filene, Blizzardous Heart Evolved",
  "Celestial Dragoon Evolved",
  "Mermaid of Punishment Evolved",
  "Adherent of Ardor Evolved",
  "Tiniest Dragon Evolved",
  "Valnareik, Lustful Desire Evolved",
  "Yuzuki, Bloodlord Evolved",
  "Adherent of Desire Evolved",
  "Adherent of Screams Evolved",
  "Marwynn, Repose of Despair Evolved",
  "Shiro, Cursed Wings Evolved",
  "Adherent of Despair Evolved",
  "Temple Healer Evolved",
  "Gilnelise, Ravenous Craving Evolved",
  "Arael Evolved",
  "Mechanical Analyzer Evolved",
  "Nomadic Conductor Evolved",
  "Hozumi, Enchanting Hostess Evolved",
  "Bastion of Seasons Evolved",
  "Elven Waitress Evolved",
  "Karakuri Servant Evolved",
  "Taketsumi, Beginning of Paradise ADVANCED",
  "Mars, Belligerent Flame Evolved",
  "Jiemon, Thief Lord Evolved",
  "Masterful Musician Evolved",
  "Front Desk Frog Evolved",
  "Riley, Astral Shaman Evolved",
  "Bergent, Layered Sorceress Evolved",
  "Orchestral Mage Evolved",
  "Chakram Wizard Evolved",
  "Si Long, Draconic God-Queen Evolved",
  "Frostbite Dragon Evolved",
  "Dragonfolk Stoker Evolved",
  "Dragon Breeder Evolved",
  "Itsurugi, End of Paradise ADVANCED",
  "Paracelise, Demon of Greed Evolved",
  "Anisage, Lost Forsaken Evolved",
  "Briared Vampire Evolved",
  "Silvernail Blaster Evolved",
  "All-Feeling Divine Evolved",
  "Nekhbet Evolved",
  "Winged Gatekeeper Evolved",
  "Twinblade Featherfolk Evolved",
  "Magna Saber Evolved",
  "Glistering Angel Evolved",
  "Gunslinger Automaton Evolved",
  "Brave Goblin Evolved",
  "Hokko Tarumae Evolved",
  "Gentildonna Evolved",
  "Cheval Grand Evolved",
  "Neo Universe Evolved",
  "Hishi Miracle Evolved",
  "Satono Crown Evolved",
  "Sekka, Ninefold Blaze ADVANCED",
  "Aria, Miasma Fairy Evolved",
  "Nelcha, Fashion Hazard Evolved",
  "Sunbright Elf Evolved",
  "Fairy Slugger Evolved",
  "Albert, Thunderous Doom Evolved",
  "Sera, Maiden of the Dawn Evolved",
  "Lounes, Levin Apprentice Evolved",
  "Mina, Levin Vice Leader Evolved",
  "Ghios, Sparkling Prism Evolved",
  "Rending Blast ADVANCED",
  "Mileka, Celestial Seer Evolved",
  "Grimoire Sorcerer Evolved",
  "Magical Squirrel Evolved",
  "Drache, Fiery Dragonlord Evolved",
  "Godfire Phoenix Evolved",
  "Flame Pillar Dragonewt Evolved",
  "Margarite Mermaid Evolved",
  "Aluzard, Timeworn Vampire Evolved",
  "Ceres, Bride of the Night Evolved",
  "Liberté, Unchained Wolf Evolved",
  "Linkstaff Necromancer Evolved",
  "Jeanne, Despair's Maiden Evolved",
  "Lunerian Paladin Evolved",
  "Pyne, Twisted Justice Evolved",
  "Charitable Al-mi'raj Evolved",
  "Sahaquiel & Israfil Evolved",
  "Miriam, Mutinous Being Evolved",
  "Managrocer Evolved",
  "Armored Goblin Evolved",
  "Elf Queen of Abundant Life Evolved",
  "Carbuncle, Immortal Jewel Evolved",
  "Forest Defender Evolved",
  "Forest Hatcheteer Evolved",
  "Patrick, Rhiceros Knight Evolved",
  "Ironfist Beast Warrior Evolved",
  "Nano, the Dawnblade Evolved",
  "Lilje, Butler of the Mists Evolved",
  "Belphomet, Worldreaver Evolved",
  "Regalore, Steel Chimera Evolved",
  "Chaos Wielder Evolved",
  "Gigahand Golem Evolved",
  "Shipsbane Plesiosaurus Evolved",
  "Steelcap Pachycephalosaurus Evolved",
  "Assault Dragoon Evolved",
  "Dragoon Medic Evolved",
  "Neun, Daybreak Vampire Evolved",
  "Jackshovel Gravedigger Evolved",
  "Liberté, Werewolf Pup Evolved",
  "Bloodstained Berserker Evolved",
  "Rola, Inferno Dragoon Evolved",
  "Gullias, Silverbeast Lord Evolved",
  "Holylight Convert Evolved",
  "Sol Sister Evolved",
  "Changewing Cherub Evolved",
  "Romantic Chanteuse Evolved",
  "Plucky Treasure Hunter Evolved",
  "Loxis, Homestead Pioneer Evolved",
  "Terrorformer Evolved",
  "Varmint Hunter Evolved",
  "Lookout Elf Evolved",
  "Bunny & Baron, Specter Duo Evolved",
  "Reinhardt, the Deathless Evolved",
  "Stalwart Slinger Evolved",
  "Shinobi Tanuki Evolved",
  "Vincent, the Peacekeeper Evolved",
  "Magical Gunslinger Evolved",
  "Artistic Arcanist Evolved",
  "Crystal Fencer Evolved",
  "Reggie, Peerless Artisan Evolved",
  "Georgius Evolved",
  "Azureflame Dragonewt Evolved",
  "Mermaid Guide Evolved",
  "Iceschillendrig, Gilded Autocrat Evolved",
  "Hazhan, Demonblade Knight Evolved",
  "Wretch Evolved",
  "Redcap Evolved",
  "Anvelt, Judgment's Cannon Evolved",
  "Vengeful Sniper Evolved",
  "Set Evolved",
  "Enchanted Knight Evolved",
  "Sylvia, Grand Arbiter Evolved",
  "Quixotic Adventurer Evolved",
  "Wandering Chef Evolved",
  "Rivaylian Bandit Evolved",
  "King of Knights, Alfred",
  "Blaster Blade Evolved",
  "Dragonic Overlord Evolved",
  "Embodiment of Victory, Aleph",
  "Blue Storm Supreme Dragon, Glory Maelstrom",
  "Navalgazer Dragon",
  "Soul Saver Dragon",
  "Nightmare Doll, Alice Evolved",
  "Barking Manticore",
  "Blazing Flare Dragon",
  "Phantom Blaster Dragon Evolved",
  "Blaster Dark Evolved",
  "CEO Amaterasu Evolved",
  "Silent Tom Evolved",
  "Drive Point",
  "XII. Wolfraud, The Hanged Man Evolved",
  "Spinaria & Lucille, Keepers ADVANCED",
  "Chipper Skipper Evolved",
  "Salvia Panther Evolved",
  "Reclusive Ponderer Evolved",
  "VII. Oluon, Runaway Chariot ADVANCED",
  "Alyaska, War Hawker Evolved",
  "Prudent General Evolved",
  "Lightning Kicker Evolved",
  "Honorable Thief Evolved",
  "0. Lhynkal, The Fool Evolved",
  "Imperator of Magic Evolved",
  "Juggling Moggy Evolved",
  "Piquant Potioneer Evolved",
  "XI. Erntz, Justice Evolved",
  "Lævateinn Dragon, Dual Form α ADVANCED",
  "Lævateinn Dragon, Dual Form β ADVANCED",
  "Lævateinn Dragon, Dual Form γ ADVANCED",
  "Slaughering Dragonewt Evolved",
  "Swiftblade Dragonewt Evolved",
  "Springwell Dragon Keeper Evolved",
  "VI. Milteo, The Lovers Evolved",
  "Sincere Masquerade Ghost ADVANCED",
  "Deathbringer Evolved",
  "Ghost Maid Evolved",
  "Moonrise Werewolf Evolved",
  "VIII. Sofina, Strength Evolved",
  "Reverend Adjudicator Evolved",
  "Topaz Swordian Evolved",
  "Priestess of Foresight Evolved",
  "XXI. Zelgenea, O Great World ADVANCED",
  "Starbright Deity Evolved",
  "One-Winged Traitor Evolved",
  "Pureshot Angel Evolved",
  "White Vanara Evolved",
  "Paula, Gentle Warmth",
  "Storied Falconer Evolved",
  "Grasshopper Conductor Evolved",
  "Celia, Hope's Strategist",
  "Prim, Innocent Princess Evolved",
  "Dario, Demon Count Evolved",
  "Axe Princess Evolved",
  "Ceridwen, Eternity Hunter Evolved",
  "Grea, Mysterian Dragoness Evolved",
  "Mysterian Whitewyrm",
  "Bergent, Onion Patchmaster Evolved",
  "Vayle, Mysterian Summoner Evolved",
  "Witch of Foresight Evolved",
  "Jerva of Draconic Mail Evolved",
  "Romelia, Lightning Striker Evolved",
  "Virtuous Lindworm",
  "Roy, Dragoncleaver Evolved",
  "Katakura Kojuro Evolved",
  "Heroic Dragonslayer Evolved",
  "Vania, Kind Queen",
  "Oldblood King Evolved",
  "Big Soul Hunter Evolved",
  "Orator of the Bones Evolved",
  "Jeanne, Beacon of Salvation Evolved",
  "Ceryneian Lighthind",
  "Jeweled Priestess Evolved",
  "Lycaon Evolved",
  "Marduk Evolved",
  "Paradise Vanguard Evolved",
  "Suttungr Evolved",
  "Valkyrie of Chaos Evolved",
  "Orchis, Resolute Puppet",
  "Zwei, Murderous Puppet Evolved",
  "Michelle, the Mind Reader Evolved",
  "Insane Dark Elf Evolved",
  "Dionne, Dancing Blade Evolved",
  "Roland the Incorruptible Evolved",
  "Azord, Duke of the Mists Evolved",
  "Mana Pistol Merc Evolved",
  "Sweet-Tooth Medusa Evolved",
  "Unbodied Witch Evolved",
  "Elusa, Magic Wunderkind Evolved",
  "Rabbit Mage Evolved",
  "Azi Dahaka Evolved",
  "Annerose Evolved",
  "Elios, Loyal Dragoon Evolved",
  "Geovore Evolved",
  "Crimson Rose Queen Evolved",
  "Tartarus, the Tormentor Evolved",
  "Chris Pumpkinhead Evolved",
  "Marian the Mummy Evolved",
  "Godsworn Alexiel Evolved",
  "Eidolon of Madness Evolved",
  "Collete, Holy Gunner Evolved",
  "Temple Windbear Evolved",
  "Alterplane Arbiter Evolved",
  "Sahaquiel Evolved",
  "Reina, Evolution's Herald Evolved",
  "High Enchantress Evolved",
  "Ladica, the Stoneclaw Evolved",
  "Setus, the Beastblade Evolved",
  "Blossom Spirit Evolved",
  "Forest Hermit Evolved",
  "Bayleon, Sovereign Light Evolved",
  "Leod, the Crescent Blade Evolved",
  "Troya, Thunder of Hagelberg Evolved",
  "Dauntless Commander Evolved",
  "Tetra, Sapphire Rebel Evolved",
  "Eleanor, Cosmic Flower Evolved",
  "Displacer Bot Evolved",
  "Magiblade Witch Evolved",
  "Valdain, Cursed Shadow Evolved",
  "Marion, Elegant Dragonewt Evolved",
  "Hoarfrost Triceratops Evolved",
  "Doting Dragoneer Evolved",
  "Mono, Garnet Rebel Evolved",
  "Doublame, Duke and Dame Evolved",
  "Nicola, Forbidden Strength Evolved",
  "Berserk Demon Evolved",
  "Limonia, Flawed Saint Evolved",
  "Marione, Light of Balance Evolved",
  "Robofalcon Evolved",
  "Dark Bishop Evolved",
  "Viridia Magna Evolved",
  "Maisha, Hero of Purgation Evolved",
  "Robogoblin Evolved",
  "Aldis, Trendsetting Seraph Evolved",
  "Momoka Sakurai Evolved",
  "Akiha Ikebukuro Evolved",
  "Nene Kurihara Evolved",
  "Yukimi Sajo Evolved",
  "Kako Takafuji Evolved",
  "Seira Mizuki Evolved",
  "Suzuho Ueda Evolved",
  "Miria Akagi Evolved",
  "Kumiko Matsuyama Evolved",
  "Aiko Takamori Evolved",
  "Yuzu Kitami Evolved",
  "Yumi Aiba Evolved",
  "Kana Imai Evolved",
  "Kyoko Igarashi Evolved",
  "Uzuki Shimamura Evolved",
  "Karen Hojo Evolved",
  "Miho Kohinata Evolved",
  "Shiki Ichinose Evolved",
  "Kanade Hayami Evolved",
  "Hina Araki Evolved",
  "Rika Jougasaki Evolved",
  "Yui Ohtsuki Evolved",
  "Tsukasa Kiryu Evolved",
  "Yuka Nakano Evolved",
  "Noa Takamine Evolved",
  "Ranko Kanzaki Evolved",
  "Takumi Mukai Evolved",
  "Aki Yamato Evolved",
  "Syoko Hoshi Evolved",
  "Shin Sato Evolved",
  "Nana Abe Evolved",
  "Haru Yuuki Evolved",
  "Layla Evolved",
  "Lymaga, Forest Champion Evolved",
  "Wildwood Matriarch Evolved",
  "Woodland Cleaver Evolved",
  "Mallet Monkey Evolved",
  "Ralmia, Sonic Racer Evolved",
  "Hero of Antiquity Evolved",
  "Quickdraw Maven Evolved",
  "Samurai Outlaw Evolved",
  "Mysteria, Magic Founder Evolved",
  "Curse Crafter Evolved",
  "Demoncaller Evolved",
  "Charming Gentlemouse Evolved",
  "Garyu, Surpreme Dragonkin Evolved",
  "Wyrm God of the Skies Evolved",
  "Ice Dancing Dragonewt Evolved",
  "Dragonblader Evolved",
  "Ginsetsu, Great Fox Evolved",
  "Shuten-Doji Evolved",
  "Cougar Pelt Warrior Evolved",
  "Zashiki-Warashi Evolved",
  "Karula, Arts Master Evolved",
  "Phantom Blade Wielder Evolved",
  "Holy Lancer Evolved",
  "Barrage Brawler Evolved",
  "Badb Catha Evolved",
  "Mithra, Daybreak Diety Evolved",
  "Chaht, Ringside Announcer Evolved",
  "Bazooka Goblins Evolved",
  "Izudia, Omen of Unkilling Evolved",
  "Apostle of Unkilling Evolved",
  "Noah, Vengeful Puppeteer Evolved",
  "Flower Doll Evolved",
  "Octrice, Omen of Usurpation Evolved",
  "Apostle of Usurpation Evolved",
  "Geno, Machine Artisan Evolved",
  "Captain Meteo Evolved",
  "Raio, Omen of Truth Evolved",
  "Apostle of Truth Evolved",
  "Iron Staff Mechanic Evolved",
  "Servant of Destruction Evolved",
  "Galmieux, Omen of Disdain Evolved",
  "Apostle of Disdain Evolved",
  "Cursed Stone Evolved",
  "Airship Whale Evolved",
  "Rulenye, Omen of Silence Evolved",
  "Apostle of Silence Evolved",
  "Masked Puppet Evolved",
  "Servant of Lust Evolved",
  "Marwynn, Omen of Repose Evolved",
  "Apostle of Repose Evolved",
  "Unidentified Subject Evolved",
  "Demon's Epitaph Evolved",
  "Mjerrabaine, Omen of One Evolved",
  "Apostle of Craving Evolved",
  "Rosa, Mech Wing Maiden Evolved",
  "Cat Cannoneer Evolved",
  "Deepwood Anomaly Evolved",
  "King Elephant Evolved",
  "Sukuna, Brave and Small Evolved",
  "Fita the Gentle Elf Evolved",
  "Mars, Silent Flame General Evolved",
  "Barbarossa Evolved",
  "Shrouded Assassin Evolved",
  "Tristan of the Round Table Evolved",
  "Wordwielder Ginger Evolved",
  "Europa Evolved",
  "Magic Illusionist Evolved",
  "Dazzling Healer Evolved",
  "Python Evolved",
  "Lævateinn Dragon, Defense Form Evolved",
  "Lævateinn Dragon, Blast Form Evolved",
  "Star Phoenix Evolved",
  "Cetus Evolved",
  "Hippocampus Evolved",
  "Howling Demon Evolved",
  "Stheno Evolved",
  "Fenrir Evolved",
  "Frogbat Evolved",
  "Dark Jeanne Evolved",
  "Zoe, Princess of Goldenia Evolved",
  "Star Priestess Evolved",
  "Mist Shaman Evolved",
  "Israfil Evolved",
  "Grimnir, War Cyclone Evolved",
  "Goblin Princess Evolved",
  "Owlcat Evolved",
  "Cosmos Fang Evolved",
  "Slade Blossoming Wolf Evolved",
  "Gerbera Bear Evolved",
  "Tweedle Dum, Tweedle Dee Evolved",
  "Valiant Fencer Evolved",
  "Amerro, Spear Knight Evolved",
  "Mach Knight Evolved",
  "Bladed Hedgehog Evolved",
  "Mystic King Evolved",
  "Milady, Mystic Queen Evolved",
  "Magical Knight Evolved",
  "Witch of Sweets Evolved",
  "Lævateinn Dragon Evolved",
  "Lævateinn Dragon Attack Form Evolved",
  "Draconir, Knuckle Dragon Evolved",
  "Hammer Dragonewt Evolved",
  "Dragon Summoner Evolved",
  "Masquerade Ghost Evolved",
  "Baccherus, Peppy Ghostie Evolved",
  "Trombone Devil Evolved",
  "Mischievous Zombie Evolved",
  "Diamond Master Evolved",
  "Wingy Chirpy Gemstone Evolved",
  "Ruby Falcon Evolved",
  "Pinion Prince Evolved",
  "Alice, Wonderland Explorer Evolved",
  "Garuel, Seraphic Leo Evolved",
  "Humpty Dumpty Evolved",
  "Harbringer of the Night Evolved",
  "Silence Suzuka Evolved",
  "Tokai Teio Evolved",
  "Agnes Tachyon Evolved",
  "Special Week Evolved",
  "Maruzensky Evolved",
  "Mejiro McQueen Evolved",
  "Carrot",
  "Crystalia Tia Evolved",
  "Grand Archer Seiwyn Evolved",
  "Crystalia Lily Evolved",
  "Forest Gigas Evolved",
  "Albert Levin Saber Evolved",
  "Leonidas Evolved",
  "Jeno, Levin Vanguard Evolved",
  "Avant Blader Evolved",
  "Daria Dimensional Witch Evolved",
  "Anne, Belle of Mysteria Evolved",
  "Remi & Rami, Witchy Duo Evolved",
  "Craig, Wizard of Mysteria Evolved",
  "Imperial Dragoon Evolved",
  "Neptune Evolved",
  "Siegfried Evolved",
  "Dragontamer Evolved",
  "Soul Dealer Evolved",
  "Azazel Evolved",
  "Veight, Vampire Noble Evolved",
  "Demonic Hedonist Evolved",
  "Heavenly Aegis Evolved",
  "Kaguya Evolved",
  "Radiance Angel Evolved",
  "Soul Collector Evolved",
  "Bahamut Evolved",
  "Archangel Reina Evolved",
  "Unicorn Dancer Unicorn Evolved",
  "Sektor Evolved",
  "Priest of the Cudgel Evolved",
  "Ardent Nun Evolved",
  "Guardian Nun Evolved",
  "Playful Necromancer Evolved",
  "Lesser Mummy Evolved",
  "Lilith Evolved",
  "Dragon Warrior Evolved",
  "Roc Evolved",
  "Dragonrider Evolved",
  "Demonflame Mage Evolved",
  "Penguin Wizard Evolved",
  "Sammy Wizard's Apprentice Evolved",
  "Floral Fencer Evolved",
  "Oathless Knight Evolved",
  "Quickblader Evolved",
  "Rose Gardener Evolved",
  "Treant Evolved",
  "Water Fairy Evolved",
  "Ancient Elf Evolved",
  "Rhinoceroach Evolved",
  "Elven Princess Mage Evolved",
  "Archer Evolved",
  "Sea Queen Otohime Evolved",
  "Shadowed Assassin Evolved",
  "Maid Leader Evolved",
  "Fervid Soldier Evolved",
  "Merlin Evolved",
  "Ancient Alchemist Evolved",
  "Spectral Wizard Evolved",
  "Crafty Warlock Evolved",
  "Dark Dragoon Forte Evolved",
  "Shapeshifting Mage Evolved",
  "Shenlong Evolved",
  "Ivory Dragon Evolved",
  "Cerberus Evolved",
  "Righteous Devil Evolved",
  "Crazed Executioner Evolved",
  "Wardrobe Raider Evolved",
  "Jeanne d'Arc Evolved",
  "Arch Priestess Laelia Evolved",
  "Prism Priestess Evolved",
  "Mainyu Evolved",
  "Lucifer Evolved",
  "Urd Evolved",
  "Bellringer Angel Evolved",
  "Goblinmount Demon Evolved",
  "Goblin Evolved",
  "Goliath Evolved",
  "Healing Angel Evolved",
];

export const set16Evo = [
  "Aria, Lady of the Woods Evolved",
  "Glade, Fragrantwood Ward Evolved",
  "Aerin, Crystalian Frostward Evolved",
  "Fairy Tamer Evolved",

  "Amelia, Silver Captain Evolved",
  "Zirconia, Ironcrown Ward Evolved",
  "Luminous Commander Evolved",
  "Flashstep Quickblader Evolved",

  "Lilanthim, Anathema of Edacity Evolved",
  "Zizdvend, Fate's Arbiter Evolved",
  "Edelweiss, Sagelight Ward Evolved",
  "Penelope, Potions Prodigy Evolved",
  "Starry-Eyed Penguin Wizard Evolved",

  "Burnite, Anathema of Flame Evolved",
  "Nirle, Draconic Prodigy Evolved",
  "Liu Feng, Goldennote Ward Evolved",
  "Eyfa, Windrider Evolved",
  "Little Dragon Nanny Evolved",

  "Aragavy, Eternal Hunter Evolved",
  "Mukan, Shadowcrypt Ward Evolved",
  "Orthrus, Hellhound Blader Evolved",
  "Vlad, Impaler Evolved",

  "Rodeo, Anathema of Judgment Evolved",
  "Ronavero, Darkhaven Ward Evolved",
  "Angelic Prism Priestess Evolved",
  "Ironfist Priest Evolved",

  "Olivia, Heroic Dark Angel Evolved",
  "Phildau, Lionheart Ward Evolved",
  "Apollo, Heaven's Envoy Evolved",
];

export const set15Evo = [
  "Amataz, Reverse Blader Evolved",
  "Piercye, Queen of Frost Evolved",
  "Inauspicious Puppeteer Evolved",
  "Cryptid Keeper Evolved",
  "Hermit of Unkilling Evolved",

  "Kagemitsu, Lost Samurai Evolved",
  "Arsène Lupin Evolved",
  "Adherent of Hollowness Evolved",
  "Penguin Guardian Evolved",

  "Lishenna, Melodious Destruction Evolved",
  "Noble Shikigami ADVANCED",
  "Acid Golem Evolved",
  "Adherent of Elimination Evolved",
  "Scroll Wizard Evolved",

  "Filene, Blizzardous Heart Evolved",
  "Celestial Dragoon Evolved",
  "Mermaid of Punishment Evolved",
  "Adherent of Ardor Evolved",
  "Tiniest Dragon Evolved",

  "Valnareik, Lustful Desire Evolved",
  "Yuzuki, Bloodlord Evolved",
  "Adherent of Desire Evolved",
  "Adherent of Screams Evolved",

  "Marwynn, Repose of Despair Evolved",
  "Shiro, Cursed Wings Evolved",
  "Adherent of Despair Evolved",
  "Temple Healer Evolved",

  "Gilnelise, Ravenous Craving Evolved",
  "Arael Evolved",
  "Mechanical Analyzer Evolved",
  "Nomadic Conductor Evolved",
];

export const set14Evo = [
  "Hozumi, Enchanting Hostess Evolved",
  "Bastion of Seasons Evolved",
  "Elven Waitress Evolved",
  "Karakuri Servant Evolved",

  "Taketsumi, Beginning of Paradise ADVANCED",
  "Mars, Belligerent Flame Evolved",
  "Jiemon, Thief Lord Evolved",
  "Masterful Musician Evolved",
  "Front Desk Frog Evolved",

  "Riley, Astral Shaman Evolved",
  "Bergent, Layered Sorceress Evolved",
  "Orchestral Mage Evolved",
  "Chakram Wizard Evolved",

  "Si Long, Draconic God-Queen Evolved",
  "Frostbite Dragon Evolved",
  "Dragonfolk Stoker Evolved",
  "Dragon Breeder Evolved",

  "Itsurugi, End of Paradise ADVANCED",
  "Paracelise, Demon of Greed Evolved",
  "Anisage, Lost Forsaken Evolved",
  "Briared Vampire Evolved",
  "Silvernail Blaster Evolved",

  "All-Feeling Divine Evolved",
  "Nekhbet Evolved",
  "Winged Gatekeeper Evolved",
  "Twinblade Featherfolk Evolved",

  "Magna Saber Evolved",
  "Glistering Angel Evolved",
  "Gunslinger Automaton Evolved",
  "Brave Goblin Evolved",
];

export const setUMA2Evo = [
  "Hokko Tarumae Evolved",

  "Gentildonna Evolved",

  "Cheval Grand Evolved",

  "Neo Universe Evolved",

  "Hishi Miracle Evolved",

  "Satono Crown Evolved",
];

export const set13Evo = [
  "Sekka, Ninefold Blaze ADVANCED",
  "Aria, Miasma Fairy Evolved",
  "Nelcha, Fashion Hazard Evolved",
  "Sunbright Elf Evolved",
  "Fairy Slugger Evolved",

  "Albert, Thunderous Doom Evolved",
  "Sera, Maiden of the Dawn Evolved",
  "Lounes, Levin Apprentice Evolved",
  "Mina, Levin Vice Leader Evolved",

  "Ghios, Sparkling Prism Evolved",
  "Rending Blast ADVANCED",
  "Mileka, Celestial Seer Evolved",
  "Grimoire Sorcerer Evolved",
  "Magical Squirrel Evolved",

  "Drache, Fiery Dragonlord Evolved",
  "Godfire Phoenix Evolved",
  "Flame Pillar Dragonewt Evolved",
  "Margarite Mermaid Evolved",

  "Aluzard, Timeworn Vampire Evolved",
  "Ceres, Bride of the Night Evolved",
  "Liberté, Unchained Wolf Evolved",
  "Linkstaff Necromancer Evolved",

  "Jeanne, Despair's Maiden Evolved",
  "Lunerian Paladin Evolved",
  "Pyne, Twisted Justice Evolved",
  "Charitable Al-mi'raj Evolved",

  "Sahaquiel & Israfil Evolved",
  "Miriam, Mutinous Being Evolved",
  "Managrocer Evolved",
  "Armored Goblin Evolved",
];

export const set12Evo = [
  "Elf Queen of Abundant Life Evolved",
  "Carbuncle, Immortal Jewel Evolved",
  "Forest Defender Evolved",
  "Forest Hatcheteer Evolved",

  "Patrick, Rhiceros Knight Evolved",
  "Ironfist Beast Warrior Evolved",
  "Nano, the Dawnblade Evolved",
  "Lilje, Butler of the Mists Evolved",

  "Belphomet, Worldreaver Evolved",
  "Regalore, Steel Chimera Evolved",
  "Chaos Wielder Evolved",
  "Gigahand Golem Evolved",

  "Shipsbane Plesiosaurus Evolved",
  "Steelcap Pachycephalosaurus Evolved",
  "Assault Dragoon Evolved",
  "Dragoon Medic Evolved",

  "Neun, Daybreak Vampire Evolved",
  "Jackshovel Gravedigger Evolved",
  "Liberté, Werewolf Pup Evolved",
  "Bloodstained Berserker Evolved",

  "Rola, Inferno Dragoon Evolved",
  "Gullias, Silverbeast Lord Evolved",
  "Holylight Convert Evolved",
  "Sol Sister Evolved",

  "Changewing Cherub Evolved",
  "Romantic Chanteuse Evolved",
  "Plucky Treasure Hunter Evolved",
];

export const set11Evo = [
  "Loxis, Homestead Pioneer Evolved",
  "Terrorformer Evolved",
  "Varmint Hunter Evolved",
  "Lookout Elf Evolved",

  "Bunny & Baron, Specter Duo Evolved",
  "Reinhardt, the Deathless Evolved",
  "Stalwart Slinger Evolved",
  "Shinobi Tanuki Evolved",

  "Vincent, the Peacekeeper Evolved",
  "Magical Gunslinger Evolved",
  "Artistic Arcanist Evolved",
  "Crystal Fencer Evolved",

  "Reggie, Peerless Artisan Evolved",
  "Georgius Evolved",
  "Azureflame Dragonewt Evolved",
  "Mermaid Guide Evolved",

  "Iceschillendrig, Gilded Autocrat Evolved",
  "Hazhan, Demonblade Knight Evolved",
  "Wretch Evolved",
  "Redcap Evolved",

  "Anvelt, Judgment's Cannon Evolved",
  "Vengeful Sniper Evolved",
  "Set Evolved",
  "Enchanted Knight Evolved",

  "Sylvia, Grand Arbiter Evolved",
  "Quixotic Adventurer Evolved",
  "Wandering Chef Evolved",
  "Rivaylian Bandit Evolved",
];

export const setVGEvo = [
  "King of Knights, Alfred",
  "Blaster Blade Evolved",

  "Dragonic Overlord Evolved",
  "Embodiment of Victory, Aleph",

  "Blue Storm Supreme Dragon, Glory Maelstrom",
  "Navalgazer Dragon",

  "Soul Saver Dragon",

  "Nightmare Doll, Alice Evolved",
  "Barking Manticore",

  "Blazing Flare Dragon",

  "Phantom Blaster Dragon Evolved",
  "Blaster Dark Evolved",

  "CEO Amaterasu Evolved",
  "Silent Tom Evolved",

  "Drive Point",
];

export const set10Evo = [
  "XII. Wolfraud, The Hanged Man Evolved",
  "Spinaria & Lucille, Keepers ADVANCED",
  "Chipper Skipper Evolved",
  "Salvia Panther Evolved",
  "Reclusive Ponderer Evolved",

  "VII. Oluon, Runaway Chariot ADVANCED",
  "Alyaska, War Hawker Evolved",
  "Prudent General Evolved",
  "Lightning Kicker Evolved",
  "Honorable Thief Evolved",

  "0. Lhynkal, The Fool Evolved",
  "Imperator of Magic Evolved",
  "Juggling Moggy Evolved",
  "Piquant Potioneer Evolved",

  "XI. Erntz, Justice Evolved",
  "Lævateinn Dragon, Dual Form α ADVANCED",
  "Lævateinn Dragon, Dual Form β ADVANCED",
  "Lævateinn Dragon, Dual Form γ ADVANCED",
  "Slaughering Dragonewt Evolved",
  "Swiftblade Dragonewt Evolved",
  "Springwell Dragon Keeper Evolved",

  "VI. Milteo, The Lovers Evolved",
  "Sincere Masquerade Ghost ADVANCED",
  "Deathbringer Evolved",
  "Ghost Maid Evolved",
  "Moonrise Werewolf Evolved",

  "VIII. Sofina, Strength Evolved",
  "Reverend Adjudicator Evolved",
  "Topaz Swordian Evolved",
  "Priestess of Foresight Evolved",

  "XXI. Zelgenea, O Great World ADVANCED",
  "Starbright Deity Evolved",
  "One-Winged Traitor Evolved",
  "Pureshot Angel Evolved",
];

export const set9Evo = [
  "White Vanara Evolved",
  "Paula, Gentle Warmth",
  "Storied Falconer Evolved",
  "Grasshopper Conductor Evolved",

  "Celia, Hope's Strategist",
  "Prim, Innocent Princess Evolved",
  "Dario, Demon Count Evolved",
  "Axe Princess Evolved",

  "Ceridwen, Eternity Hunter Evolved",
  "Grea, Mysterian Dragoness Evolved",
  "Mysterian Whitewyrm",
  "Bergent, Onion Patchmaster Evolved",
  "Vayle, Mysterian Summoner Evolved",
  "Witch of Foresight Evolved",

  "Jerva of Draconic Mail Evolved",
  "Romelia, Lightning Striker Evolved",
  "Virtuous Lindworm",
  "Roy, Dragoncleaver Evolved",
  "Katakura Kojuro Evolved",
  "Heroic Dragonslayer Evolved",

  "Vania, Kind Queen",
  "Oldblood King Evolved",
  "Big Soul Hunter Evolved",
  "Orator of the Bones Evolved",

  "Jeanne, Beacon of Salvation Evolved",
  "Ceryneian Lighthind",
  "Jeweled Priestess Evolved",
  "Lycaon Evolved",

  "Marduk Evolved",
  "Paradise Vanguard Evolved",
  "Suttungr Evolved",
  "Valkyrie of Chaos Evolved",
];

export const set8Evo = [
  "Orchis, Resolute Puppet",
  "Zwei, Murderous Puppet Evolved",
  "Michelle, the Mind Reader Evolved",
  "Insane Dark Elf Evolved",

  "Dionne, Dancing Blade Evolved",
  "Roland the Incorruptible Evolved",
  "Azord, Duke of the Mists Evolved",
  "Mana Pistol Merc Evolved",

  "Sweet-Tooth Medusa Evolved",
  "Unbodied Witch Evolved",
  "Elusa, Magic Wunderkind Evolved",
  "Rabbit Mage Evolved",

  "Azi Dahaka Evolved",
  "Annerose Evolved",
  "Elios, Loyal Dragoon Evolved",
  "Geovore Evolved",

  "Crimson Rose Queen Evolved",
  "Tartarus, the Tormentor Evolved",
  "Chris Pumpkinhead Evolved",
  "Marian the Mummy Evolved",

  "Godsworn Alexiel Evolved",
  "Eidolon of Madness Evolved",
  "Collete, Holy Gunner Evolved",
  "Temple Windbear Evolved",

  "Alterplane Arbiter Evolved",
  "Sahaquiel Evolved",
  "Reina, Evolution's Herald Evolved",
  "High Enchantress Evolved",
];

export const set7Evo = [
  "Ladica, the Stoneclaw Evolved",
  "Setus, the Beastblade Evolved",
  "Blossom Spirit Evolved",
  "Forest Hermit Evolved",

  "Bayleon, Sovereign Light Evolved",
  "Leod, the Crescent Blade Evolved",
  "Troya, Thunder of Hagelberg Evolved",
  "Dauntless Commander Evolved",

  "Tetra, Sapphire Rebel Evolved",
  "Eleanor, Cosmic Flower Evolved",
  "Displacer Bot Evolved",
  "Magiblade Witch Evolved",

  "Valdain, Cursed Shadow Evolved",
  "Marion, Elegant Dragonewt Evolved",
  "Hoarfrost Triceratops Evolved",
  "Doting Dragoneer Evolved",

  "Mono, Garnet Rebel Evolved",
  "Doublame, Duke and Dame Evolved",
  "Nicola, Forbidden Strength Evolved",
  "Berserk Demon Evolved",

  "Limonia, Flawed Saint Evolved",
  "Marione, Light of Balance Evolved",
  "Robofalcon Evolved",
  "Dark Bishop Evolved",

  "Viridia Magna Evolved",
  "Maisha, Hero of Purgation Evolved",
  "Robogoblin Evolved",
  "Aldis, Trendsetting Seraph Evolved",
];

export const setIDOLEvo = [
  "Momoka Sakurai Evolved",
  "Akiha Ikebukuro Evolved",
  "Nene Kurihara Evolved",

  "Yukimi Sajo Evolved",
  "Kako Takafuji Evolved",
  "Seira Mizuki Evolved",

  "Suzuho Ueda Evolved",
  "Miria Akagi Evolved",
  "Kumiko Matsuyama Evolved",

  "Aiko Takamori Evolved",
  "Yuzu Kitami Evolved",
  "Yumi Aiba Evolved",
  "Kana Imai Evolved",

  "Kyoko Igarashi Evolved",
  "Uzuki Shimamura Evolved",
  "Karen Hojo Evolved",
  "Miho Kohinata Evolved",

  "Shiki Ichinose Evolved",
  "Kanade Hayami Evolved",
  "Hina Araki Evolved",
  "Rika Jougasaki Evolved",

  "Yui Ohtsuki Evolved",
  "Tsukasa Kiryu Evolved",
  "Yuka Nakano Evolved",
  "Noa Takamine Evolved",

  "Ranko Kanzaki Evolved",
  "Takumi Mukai Evolved",
  "Aki Yamato Evolved",
  "Syoko Hoshi Evolved",

  "Shin Sato Evolved",
  "Nana Abe Evolved",
  "Haru Yuuki Evolved",
  "Layla Evolved",
];

export const set6Evo = [
  "Lymaga, Forest Champion Evolved",
  "Wildwood Matriarch Evolved",
  "Woodland Cleaver Evolved",
  "Mallet Monkey Evolved",

  "Ralmia, Sonic Racer Evolved",
  "Hero of Antiquity Evolved",
  "Quickdraw Maven Evolved",
  "Samurai Outlaw Evolved",

  "Mysteria, Magic Founder Evolved",
  "Curse Crafter Evolved",
  "Demoncaller Evolved",
  "Charming Gentlemouse Evolved",

  "Garyu, Surpreme Dragonkin Evolved",
  "Wyrm God of the Skies Evolved",
  "Ice Dancing Dragonewt Evolved",
  "Dragonblader Evolved",

  "Ginsetsu, Great Fox Evolved",
  "Shuten-Doji Evolved",
  "Cougar Pelt Warrior Evolved",
  "Zashiki-Warashi Evolved",

  "Karula, Arts Master Evolved",
  "Phantom Blade Wielder Evolved",
  "Holy Lancer Evolved",
  "Barrage Brawler Evolved",

  "Badb Catha Evolved",
  "Mithra, Daybreak Diety Evolved",
  "Chaht, Ringside Announcer Evolved",
  "Bazooka Goblins Evolved",
];
export const set5Evo = [
  "Izudia, Omen of Unkilling Evolved",
  "Apostle of Unkilling Evolved",
  "Noah, Vengeful Puppeteer Evolved",
  "Flower Doll Evolved",

  "Octrice, Omen of Usurpation Evolved",
  "Apostle of Usurpation Evolved",
  "Geno, Machine Artisan Evolved",
  "Captain Meteo Evolved",

  "Raio, Omen of Truth Evolved",
  "Apostle of Truth Evolved",
  "Iron Staff Mechanic Evolved",
  "Servant of Destruction Evolved",

  "Galmieux, Omen of Disdain Evolved",
  "Apostle of Disdain Evolved",
  "Cursed Stone Evolved",
  "Airship Whale Evolved",

  "Rulenye, Omen of Silence Evolved",
  "Apostle of Silence Evolved",
  "Masked Puppet Evolved",
  "Servant of Lust Evolved",

  "Marwynn, Omen of Repose Evolved",
  "Apostle of Repose Evolved",
  "Unidentified Subject Evolved",
  "Demon's Epitaph Evolved",

  "Mjerrabaine, Omen of One Evolved",
  "Apostle of Craving Evolved",
  "Rosa, Mech Wing Maiden Evolved",
  "Cat Cannoneer Evolved",
];

export const set4Evo = [
  "Deepwood Anomaly Evolved",
  "King Elephant Evolved",
  "Sukuna, Brave and Small Evolved",
  "Fita the Gentle Elf Evolved",
  "Mars, Silent Flame General Evolved",
  "Barbarossa Evolved",
  "Shrouded Assassin Evolved",
  "Tristan of the Round Table Evolved",
  "Wordwielder Ginger Evolved",
  "Europa Evolved",
  "Magic Illusionist Evolved",
  "Dazzling Healer Evolved",
  "Python Evolved",
  "Lævateinn Dragon, Defense Form Evolved",
  "Lævateinn Dragon, Blast Form Evolved",
  "Star Phoenix Evolved",
  "Cetus Evolved",
  "Hippocampus Evolved",
  "Howling Demon Evolved",
  "Stheno Evolved",
  "Fenrir Evolved",
  "Frogbat Evolved",
  "Dark Jeanne Evolved",
  "Zoe, Princess of Goldenia Evolved",
  "Star Priestess Evolved",
  "Mist Shaman Evolved",
  "Israfil Evolved",
  "Grimnir, War Cyclone Evolved",
  "Goblin Princess Evolved",
  "Owlcat Evolved",
];

export const set3Evo = [
  "Cosmos Fang Evolved",
  "Slade Blossoming Wolf Evolved",
  "Gerbera Bear Evolved",
  "Tweedle Dum, Tweedle Dee Evolved",
  "Valiant Fencer Evolved",
  "Amerro, Spear Knight Evolved",
  "Mach Knight Evolved",
  "Bladed Hedgehog Evolved",
  "Mystic King Evolved",
  "Milady, Mystic Queen Evolved",
  "Magical Knight Evolved",
  "Witch of Sweets Evolved",
  "Lævateinn Dragon Evolved",
  "Lævateinn Dragon Attack Form Evolved",
  "Draconir, Knuckle Dragon Evolved",
  "Hammer Dragonewt Evolved",
  "Dragon Summoner Evolved",
  "Masquerade Ghost Evolved",
  "Baccherus, Peppy Ghostie Evolved",
  "Trombone Devil Evolved",
  "Mischievous Zombie Evolved",
  "Diamond Master Evolved",
  "Wingy Chirpy Gemstone Evolved",
  "Ruby Falcon Evolved",
  "Pinion Prince Evolved",
  "Alice, Wonderland Explorer Evolved",
  "Garuel, Seraphic Leo Evolved",
  "Humpty Dumpty Evolved",
  "Harbringer of the Night Evolved",
];

export const setUMAEvo = [
  "Silence Suzuka Evolved",
  "Tokai Teio Evolved",
  "Agnes Tachyon Evolved",
  "Special Week Evolved",
  "Maruzensky Evolved",
  "Mejiro McQueen Evolved",
  "Carrot",
];

export const set2Evo = [
  "Crystalia Tia Evolved",
  "Grand Archer Seiwyn Evolved",
  "Crystalia Lily Evolved",
  "Forest Gigas Evolved",
  "Albert Levin Saber Evolved",
  "Leonidas Evolved",
  "Jeno, Levin Vanguard Evolved",
  "Avant Blader Evolved",
  "Daria Dimensional Witch Evolved",
  "Anne, Belle of Mysteria Evolved",
  "Remi & Rami, Witchy Duo Evolved",
  "Craig, Wizard of Mysteria Evolved",
  "Imperial Dragoon Evolved",
  "Neptune Evolved",
  "Siegfried Evolved",
  "Dragontamer Evolved",
  "Soul Dealer Evolved",
  "Azazel Evolved",
  "Veight, Vampire Noble Evolved",
  "Demonic Hedonist Evolved",
  "Heavenly Aegis Evolved",
  "Kaguya Evolved",
  "Radiance Angel Evolved",
  "Soul Collector Evolved",
  "Bahamut Evolved",
  "Archangel Reina Evolved",
  "Unicorn Dancer Unicorn Evolved",
  "Sektor Evolved",
];

export const set1Evo = [
  "Priest of the Cudgel Evolved",
  "Ardent Nun Evolved",
  "Guardian Nun Evolved",
  "Playful Necromancer Evolved",
  "Lesser Mummy Evolved",
  "Lilith Evolved",
  "Dragon Warrior Evolved",
  "Roc Evolved",
  "Dragonrider Evolved",
  "Demonflame Mage Evolved",
  "Penguin Wizard Evolved",
  "Sammy Wizard's Apprentice Evolved",
  "Floral Fencer Evolved",
  "Oathless Knight Evolved",
  "Quickblader Evolved",
  "Rose Gardener Evolved",
  "Treant Evolved",
  "Water Fairy Evolved",
  "Ancient Elf Evolved",
  "Rhinoceroach Evolved",
  "Elven Princess Mage Evolved",
  "Archer Evolved",
  "Sea Queen Otohime Evolved",
  "Shadowed Assassin Evolved",
  "Maid Leader Evolved",
  "Fervid Soldier Evolved",
  "Merlin Evolved",
  "Ancient Alchemist Evolved",
  "Spectral Wizard Evolved",
  "Crafty Warlock Evolved",
  "Dark Dragoon Forte Evolved",
  "Shapeshifting Mage Evolved",
  "Shenlong Evolved",
  "Ivory Dragon Evolved",
  "Cerberus Evolved",
  "Righteous Devil Evolved",
  "Crazed Executioner Evolved",
  "Wardrobe Raider Evolved",
  "Jeanne d'Arc Evolved",
  "Arch Priestess Laelia Evolved",
  "Prism Priestess Evolved",
  "Mainyu Evolved",
  "Lucifer Evolved",
  "Urd Evolved",
  "Bellringer Angel Evolved",
  "Goblinmount Demon Evolved",
  "Goblin Evolved",
  "Goliath Evolved",
  "Healing Angel Evolved",
];

export const forestEvo = [
  "Grand Archer Selwyn Evolved",
  "Navalgazer Dragon Evolved",
  "Orchis, Resolute Puppet Evolved",
  "Paula, Gentle Warmth Evolved",
  "Aria, Lady of the Woods Evolved",
  "Glade, Fragrantwood Ward Evolved",
  "Aerin, Crystalian Frostward Evolved",
  "Fairy Tamer Evolved",
  "Amataz, Reverse Blader Evolved",
  "Piercye, Queen of Frost Evolved",
  "Inauspicious Puppeteer Evolved",
  "Cryptid Keeper Evolved",
  "Hermit of Unkilling Evolved",
  "Hozumi, Enchanting Hostess Evolved",
  "Bastion of Seasons Evolved",
  "Elven Waitress Evolved",
  "Karakuri Servant Evolved",
  "Hokko Tarumae Evolved",
  "Sekka, Ninefold Blaze ADVANCED",
  "Aria, Miasma Fairy Evolved",
  "Nelcha, Fashion Hazard Evolved",
  "Sunbright Elf Evolved",
  "Fairy Slugger Evolved",
  "Elf Queen of Abundant Life Evolved",
  "Carbuncle, Immortal Jewel Evolved",
  "Forest Defender Evolved",
  "Forest Hatcheteer Evolved",
  "Loxis, Homestead Pioneer Evolved",
  "Terrorformer Evolved",
  "Varmint Hunter Evolved",
  "Lookout Elf Evolved",
  "Blue Storm Supreme Dragon, Glory Maelstrom",
  "Navalgazer Dragon",
  "XII. Wolfraud, The Hanged Man Evolved",
  "Spinaria & Lucille, Keepers ADVANCED",
  "Chipper Skipper Evolved",
  "Salvia Panther Evolved",
  "Reclusive Ponderer Evolved",
  "White Vanara Evolved",
  "Paula, Gentle Warmth",
  "Storied Falconer Evolved",
  "Grasshopper Conductor Evolved",
  "Orchis, Resolute Puppet",
  "Zwei, Murderous Puppet Evolved",
  "Michelle, the Mind Reader Evolved",
  "Insane Dark Elf Evolved",
  "Ladica, the Stoneclaw Evolved",
  "Setus, the Beastblade Evolved",
  "Blossom Spirit Evolved",
  "Forest Hermit Evolved",
  "Momoka Sakurai Evolved",
  "Suzuho Ueda Evolved",
  "Aiko Takamori Evolved",
  "Yuzu Kitami Evolved",
  "Yumi Aiba Evolved",
  "Kana Imai Evolved",
  "Lymaga, Forest Champion Evolved",
  "Wildwood Matriarch Evolved",
  "Woodland Cleaver Evolved",
  "Mallet Monkey Evolved",
  "Izudia, Omen of Unkilling Evolved",
  "Apostle of Unkilling Evolved",
  "Noah, Vengeful Puppeteer Evolved",
  "Flower Doll Evolved",
  "Deepwood Anomaly Evolved",
  "King Elephant Evolved",
  "Sukuna, Brave and Small Evolved",
  "Fita the Gentle Elf Evolved",
  "Cosmos Fang Evolved",
  "Slade Blossoming Wolf Evolved",
  "Gerbera Bear Evolved",
  "Tweedle Dum, Tweedle Dee Evolved",
  "Silence Suzuka Evolved",
  "Crystalia Tia Evolved",
  "Grand Archer Seiwyn Evolved",
  "Crystalia Lily Evolved",
  "Forest Gigas Evolved",
  "Rose Gardener Evolved",
  "Treant Evolved",
  "Water Fairy Evolved",
  "Ancient Elf Evolved",
  "Rhinoceroach Evolved",
  "Elven Princess Mage Evolved",
  "Archer Evolved",
  "Ladica, Verdant Claw Evolved",
  "Lococo, Little Puppeteer Evolved",
  "Beastfolk Harvester Evolved",
  "Blossom Treant Evolved",
  "Anastasia [Seize the Light] Evolved",
  "Riina Tada [Wannabe Legend] Evolved",
  "Hinako Kita [True Dream] Evolved",
  "Slade, Blossoming Wolf Evolved",
  "Blue Storm Supreme Dragon, Glory Maelstrom Evolved",
  "Rolo Rone, Verdant Purifier Evolved",
  "Verdant Authority Caretaker Evolved",
  "Verdant City Pugilist Evolved",
  "Blossoming Lunerian Evolved",
  "Verdant Law Supplicant Evolved",

  "Kokkoro Evolved",
  "Shiori Evolved",
  "Rino Evolved",
  "Lima Evolved",

  "Magachiyo, Barbed Convict Evolved",
  "Verdant Lieutenant Evolved",
  "Budding Initiate Evolved",
  "Beast Lancer Evolved",

  "Krulle, Heir to Unkilling Evolved",
  "Windbloom Sylph Evolved",
  "Supplicant of Unkilling Evolved",
  "Bearer of the Fairy Blade Evolved",

  "Lyelth, Immaculate Idol Evolved",
  "Cleaver Cat Evolved",
  "Elven Farmhand Evolved",
  "Bladebunny Evolved",

  "Shizuru & Rino Evolved",

  "Aerin, Forever Brilliant Evolved",
  "Flower Fox Evolved",
  "Wellspring Elf Princess Evolved",
  "Coldhearted Dark Elf Evolved",
];

export const swordEvo = [
  "Celia, Hope's Strategist Evolved",
  "King of Knights, Alfred Evolved",
  "Soul Saver Dragon Evolved",
  "Amelia, Silver Captain Evolved",
  "Zirconia, Ironcrown Ward Evolved",
  "Luminous Commander Evolved",
  "Flashstep Quickblader Evolved",
  "Kagemitsu, Lost Samurai Evolved",
  "Arsène Lupin Evolved",
  "Adherent of Hollowness Evolved",
  "Penguin Guardian Evolved",
  "Taketsumi, Beginning of Paradise ADVANCED",
  "Mars, Belligerent Flame Evolved",
  "Jiemon, Thief Lord Evolved",
  "Masterful Musician Evolved",
  "Front Desk Frog Evolved",
  "Gentildonna Evolved",
  "Albert, Thunderous Doom Evolved",
  "Sera, Maiden of the Dawn Evolved",
  "Lounes, Levin Apprentice Evolved",
  "Mina, Levin Vice Leader Evolved",
  "Patrick, Rhiceros Knight Evolved",
  "Ironfist Beast Warrior Evolved",
  "Nano, the Dawnblade Evolved",
  "Lilje, Butler of the Mists Evolved",
  "Bunny & Baron, Specter Duo Evolved",
  "Reinhardt, the Deathless Evolved",
  "Stalwart Slinger Evolved",
  "Shinobi Tanuki Evolved",
  "King of Knights, Alfred",
  "Blaster Blade Evolved",
  "Soul Saver Dragon",
  "VII. Oluon, Runaway Chariot ADVANCED",
  "Alyaska, War Hawker Evolved",
  "Prudent General Evolved",
  "Lightning Kicker Evolved",
  "Honorable Thief Evolved",
  "Celia, Hope's Strategist",
  "Prim, Innocent Princess Evolved",
  "Dario, Demon Count Evolved",
  "Axe Princess Evolved",
  "Dionne, Dancing Blade Evolved",
  "Roland the Incorruptible Evolved",
  "Azord, Duke of the Mists Evolved",
  "Mana Pistol Merc Evolved",
  "Bayleon, Sovereign Light Evolved",
  "Leod, the Crescent Blade Evolved",
  "Troya, Thunder of Hagelberg Evolved",
  "Dauntless Commander Evolved",
  "Miria Akagi Evolved",
  "Kumiko Matsuyama Evolved",
  "Kyoko Igarashi Evolved",
  "Uzuki Shimamura Evolved",
  "Karen Hojo Evolved",
  "Miho Kohinata Evolved",
  "Ralmia, Sonic Racer Evolved",
  "Hero of Antiquity Evolved",
  "Quickdraw Maven Evolved",
  "Samurai Outlaw Evolved",
  "Octrice, Omen of Usurpation Evolved",
  "Apostle of Usurpation Evolved",
  "Geno, Machine Artisan Evolved",
  "Captain Meteo Evolved",
  "Mars, Silent Flame General Evolved",
  "Barbarossa Evolved",
  "Shrouded Assassin Evolved",
  "Tristan of the Round Table Evolved",
  "Valiant Fencer Evolved",
  "Amerro, Spear Knight Evolved",
  "Mach Knight Evolved",
  "Bladed Hedgehog Evolved",
  "Tokai Teio Evolved",
  "Albert Levin Saber Evolved",
  "Leonidas Evolved",
  "Jeno, Levin Vanguard Evolved",
  "Avant Blader Evolved",
  "Floral Fencer Evolved",
  "Oathless Knight Evolved",
  "Quickblader Evolved",
  "Sea Queen Otohime Evolved",
  "Shadowed Assassin Evolved",
  "Maid Leader Evolved",
  "Fervid Soldier Evolved",
  "Mistolina & Bayleon Evolved",
  "Frenzied Corpsmaster Evolved",
  "Valhorean Dealer Evolved",
  "Fox Lancer Evolved",
  "Mio Honda [Cinderella Girl] Evolved",
  "Airi Totoki [Cinderella Girl] Evolved",
  "Mayu Sakuma [Love-Laden Gift] Evolved",
  "Chieri Ogata [Happiness Tune] Evolved",
  "Albert, Levin Saber Evolved",
  "Shinra, All-Discerning Evolved",
  "Bird's-Eye Investigator Evolved",
  "Cold Case Analyst Evolved",
  "Blind Spot Surveyor Evolved",
  "Monika, Cloudhall Admiral Evolved",

  "Pecorine Evolved",
  "Jun Evolved",
  "Tomo Evolved",
  "Tamaki Evolved",

  "Barbaros, Briny Convict Evolved",
  "Gildaria, Anathema of Peace Evolved",
  "Warden of Honor Evolved",
  "Storm-Wracked First Mate Evolved",
  "Felpurr Maid Evolved",

  "Sinciro, Heir to Usurpation Evolved",
  "Congregant of Usurpation Evolved",
  "Peppy Scout Evolved",
  "Comrade of the Swordmaster Evolved",

  "Galdr, Heroic Headmaster Evolved",
  "Agile Twinblader Evolved",
  "Tony, Plucky Polliwog Evolved",
  "Kitty Sergeant Evolved",

  "Armelize, Opulent Strategist Evolved",
  "Assault Knight Evolved",
  "Axe Pirate Evolved",
  "Calculating Captain Evolved",
];

export const runeEvo = [
  "Barking Manticore Evolved",
  "Daria, Dimensional Witch Evolved",
  "Mysterian Whitewyrm Evolved",
  "Lilanthim, Anathema of Edacity Evolved",
  "Zizdvend, Fate's Arbiter Evolved",
  "Edelweiss, Sagelight Ward Evolved",
  "Penelope, Potions Prodigy Evolved",
  "Starry-Eyed Penguin Wizard Evolved",
  "Lishenna, Melodious Destruction Evolved",
  "Noble Shikigami ADVANCED",
  "Acid Golem Evolved",
  "Adherent of Elimination Evolved",
  "Scroll Wizard Evolved",
  "Riley, Astral Shaman Evolved",
  "Bergent, Layered Sorceress Evolved",
  "Orchestral Mage Evolved",
  "Chakram Wizard Evolved",
  "Cheval Grand Evolved",
  "Ghios, Sparkling Prism Evolved",
  "Rending Blast ADVANCED",
  "Mileka, Celestial Seer Evolved",
  "Grimoire Sorcerer Evolved",
  "Magical Squirrel Evolved",
  "Belphomet, Worldreaver Evolved",
  "Regalore, Steel Chimera Evolved",
  "Chaos Wielder Evolved",
  "Gigahand Golem Evolved",
  "Vincent, the Peacekeeper Evolved",
  "Magical Gunslinger Evolved",
  "Artistic Arcanist Evolved",
  "Crystal Fencer Evolved",
  "Nightmare Doll, Alice Evolved",
  "Barking Manticore",
  "0. Lhynkal, The Fool Evolved",
  "Imperator of Magic Evolved",
  "Juggling Moggy Evolved",
  "Piquant Potioneer Evolved",
  "Ceridwen, Eternity Hunter Evolved",
  "Grea, Mysterian Dragoness Evolved",
  "Mysterian Whitewyrm",
  "Bergent, Onion Patchmaster Evolved",
  "Vayle, Mysterian Summoner Evolved",
  "Witch of Foresight Evolved",
  "Sweet-Tooth Medusa Evolved",
  "Unbodied Witch Evolved",
  "Elusa, Magic Wunderkind Evolved",
  "Rabbit Mage Evolved",
  "Tetra, Sapphire Rebel Evolved",
  "Eleanor, Cosmic Flower Evolved",
  "Displacer Bot Evolved",
  "Magiblade Witch Evolved",
  "Akiha Ikebukuro Evolved",
  "Seira Mizuki Evolved",
  "Shiki Ichinose Evolved",
  "Kanade Hayami Evolved",
  "Hina Araki Evolved",
  "Rika Jougasaki Evolved",
  "Mysteria, Magic Founder Evolved",
  "Curse Crafter Evolved",
  "Demoncaller Evolved",
  "Charming Gentlemouse Evolved",
  "Raio, Omen of Truth Evolved",
  "Apostle of Truth Evolved",
  "Iron Staff Mechanic Evolved",
  "Servant of Destruction Evolved",
  "Wordwielder Ginger Evolved",
  "Europa Evolved",
  "Magic Illusionist Evolved",
  "Dazzling Healer Evolved",
  "Mystic King Evolved",
  "Milady, Mystic Queen Evolved",
  "Magical Knight Evolved",
  "Witch of Sweets Evolved",
  "Agnes Tachyon Evolved",
  "Daria Dimensional Witch Evolved",
  "Anne, Belle of Mysteria Evolved",
  "Remi & Rami, Witchy Duo Evolved",
  "Craig, Wizard of Mysteria Evolved",
  "Demonflame Mage Evolved",
  "Penguin Wizard Evolved",
  "Sammy Wizard's Apprentice Evolved",
  "Merlin Evolved",
  "Ancient Alchemist Evolved",
  "Spectral Wizard Evolved",
  "Crafty Warlock Evolved",
  "Isabelle, Intrepid Mage Evolved",
  "Tetra, Serene Sapphire Evolved",
  "Marie, Flowery Magician Evolved",
  "Awakened Robot Evolved",
  "Sae Kobayakawa [Dancing Flowers] Evolved",
  "Hiromi Seki [Twinkle in My Eye] Evolved",
  "Sammy, Wizard's Apprentice Evolved",
  "Mana, Sterling Luster Evolved",
  "Bejeweled Supermodel Evolved",
  "Bejeweled Advisor Evolved",
  "Bejeweled Bouncer Evolved",
  "Carbuncle of Mysteria Evolved",

  "Karyl Evolved",
  "Maho Evolved",
  "Kyoka Evolved",
  "Yuki Evolved",

  "Sephie, Depraved Convict Evolved",
  "Obsessive Scholar Evolved",
  "Devoted Researcher Evolved",
  "Electrokitty Evolved",

  "Velharia, Heir to Truth Evolved",
  "Axia, Heir to Destruction Evolved",
  "Raio, Elimination Manifest Evolved",
  "Congregant of Truth Evolved",
  "Devotee of Destruction Evolved",

  "Anne, Brilliant Mage Evolved",
  "Grea, Crimson Promise Evolved",
  "Gruinne, Leonardian Provost Evolved",
  "Wolf Whisperer Evolved",

  "Misogi, Mimi & Kyoka Evolved",

  "Chrono Witch Evolved",
  "Levi, Wizard of Ages Evolved",
  "Witching Moggy Evolved",
  "Elina, Winged Evangelist Evolved",
  "Blade Mage Evolved",
];

export const dragonEvo = [
  "Blazing Flare Dragon Evolved",
  "Embodiment of Victory, Aleph Evolved",
  "Garyu, Supreme Dragonkin Evolved",
  "Lævateinn Dragon, Attack Form Evolved",
  "Slaughtering Dragonewt Evolved",
  "Virtuous Lindworm Evolved",
  "Burnite, Anathema of Flame Evolved",
  "Nirle, Draconic Prodigy Evolved",
  "Liu Feng, Goldennote Ward Evolved",
  "Eyfa, Windrider Evolved",
  "Little Dragon Nanny Evolved",
  "Filene, Blizzardous Heart Evolved",
  "Celestial Dragoon Evolved",
  "Mermaid of Punishment Evolved",
  "Adherent of Ardor Evolved",
  "Tiniest Dragon Evolved",
  "Si Long, Draconic God-Queen Evolved",
  "Frostbite Dragon Evolved",
  "Dragonfolk Stoker Evolved",
  "Dragon Breeder Evolved",
  "Neo Universe Evolved",
  "Drache, Fiery Dragonlord Evolved",
  "Godfire Phoenix Evolved",
  "Flame Pillar Dragonewt Evolved",
  "Margarite Mermaid Evolved",
  "Shipsbane Plesiosaurus Evolved",
  "Steelcap Pachycephalosaurus Evolved",
  "Assault Dragoon Evolved",
  "Dragoon Medic Evolved",
  "Reggie, Peerless Artisan Evolved",
  "Georgius Evolved",
  "Azureflame Dragonewt Evolved",
  "Mermaid Guide Evolved",
  "Dragonic Overlord Evolved",
  "Embodiment of Victory, Aleph",
  "Blazing Flare Dragon",
  "XI. Erntz, Justice Evolved",
  "Lævateinn Dragon, Dual Form α ADVANCED",
  "Lævateinn Dragon, Dual Form β ADVANCED",
  "Lævateinn Dragon, Dual Form γ ADVANCED",
  "Slaughering Dragonewt Evolved",
  "Swiftblade Dragonewt Evolved",
  "Springwell Dragon Keeper Evolved",
  "Jerva of Draconic Mail Evolved",
  "Romelia, Lightning Striker Evolved",
  "Virtuous Lindworm",
  "Roy, Dragoncleaver Evolved",
  "Katakura Kojuro Evolved",
  "Heroic Dragonslayer Evolved",
  "Azi Dahaka Evolved",
  "Annerose Evolved",
  "Elios, Loyal Dragoon Evolved",
  "Geovore Evolved",
  "Valdain, Cursed Shadow Evolved",
  "Marion, Elegant Dragonewt Evolved",
  "Hoarfrost Triceratops Evolved",
  "Doting Dragoneer Evolved",
  "Nene Kurihara Evolved",
  "Yui Ohtsuki Evolved",
  "Tsukasa Kiryu Evolved",
  "Yuka Nakano Evolved",
  "Noa Takamine Evolved",
  "Garyu, Surpreme Dragonkin Evolved",
  "Wyrm God of the Skies Evolved",
  "Ice Dancing Dragonewt Evolved",
  "Dragonblader Evolved",
  "Galmieux, Omen of Disdain Evolved",
  "Apostle of Disdain Evolved",
  "Cursed Stone Evolved",
  "Airship Whale Evolved",
  "Python Evolved",
  "Lævateinn Dragon, Defense Form Evolved",
  "Lævateinn Dragon, Blast Form Evolved",
  "Star Phoenix Evolved",
  "Cetus Evolved",
  "Hippocampus Evolved",
  "Lævateinn Dragon Evolved",
  "Lævateinn Dragon Attack Form Evolved",
  "Draconir, Knuckle Dragon Evolved",
  "Hammer Dragonewt Evolved",
  "Dragon Summoner Evolved",
  "Special Week Evolved",
  "Imperial Dragoon Evolved",
  "Neptune Evolved",
  "Siegfried Evolved",
  "Dragontamer Evolved",
  "Dragon Warrior Evolved",
  "Roc Evolved",
  "Dragonrider Evolved",
  "Dark Dragoon Forte Evolved",
  "Shapeshifting Mage Evolved",
  "Shenlong Evolved",
  "Ivory Dragon Evolved",
  "Disrestan, Ocean Harbinger Evolved",
  "Djeana, the Stouthearted Evolved",
  "Forestclaw Sentinel Evolved",
  "Shark Warrior Evolved",
  "Fumika Sagisawa [Cinderella Girl] Evolved",
  "Yui Ohtsuki [Lollipop Darling] Evolved",
  "Hotaru Shiragiku [Unbreakable] Evolved",
  "El, Destructive Dragon Evolved",
  "Dragon-Eyed Secretary Evolved",
  "Neon-Tailed Prefect Evolved",
  "Ian, Dragon Buster Evolved",
  "Lightning-Clawed Loafer Evolved",

  "Sheffy Evolved",
  "Kaya Evolved",
  "Inori Evolved",
  "Mifuyu Evolved",

  "Drazael, Ravening Enforcer Evolved",
  "Scorched-Earth Tyrant Evolved",
  "Hotheaded Marauder Evolved",
  "Dancing Crab Evolved",

  "Azurifrit, Heir to Disdain Evolved",
  "Spoiled Mermanager Evolved",
  "Supplicant of Disdain Evolved",
  "Snowstorm Dragonewt Evolved",

  "Lilium, the Witchwyrm Evolved",
  "Grand Slam Tamer Evolved",
  "Dragonborn Striker Evolved",
  "Ipupiara Evolved",

  "Ignis Dragon Evolved",
  "Noir & Blanc, Brothers Evolved",
  "Coral Spirit Evolved",
  "Hailwyrm Evolved",
  "Oguri Cap [Surging Beast] Evolved",
];

export const abyssEvo = [
  "Fortuna Regina Evolved",
  "Silvernail Markswoman Evolved",
  "Vania, Kind Queen Evolved",
  "Aragavy, Eternal Hunter Evolved",
  "Mukan, Shadowcrypt Ward Evolved",
  "Orthrus, Hellhound Blader Evolved",
  "Vlad, Impaler Evolved",
  "Valnareik, Lustful Desire Evolved",
  "Yuzuki, Bloodlord Evolved",
  "Adherent of Desire Evolved",
  "Adherent of Screams Evolved",
  "Itsurugi, End of Paradise ADVANCED",
  "Paracelise, Demon of Greed Evolved",
  "Anisage, Lost Forsaken Evolved",
  "Briared Vampire Evolved",
  "Silvernail Blaster Evolved",
  "Hishi Miracle Evolved",
  "Aluzard, Timeworn Vampire Evolved",
  "Ceres, Bride of the Night Evolved",
  "Liberté, Unchained Wolf Evolved",
  "Linkstaff Necromancer Evolved",
  "Neun, Daybreak Vampire Evolved",
  "Jackshovel Gravedigger Evolved",
  "Liberté, Werewolf Pup Evolved",
  "Bloodstained Berserker Evolved",
  "Iceschillendrig, Gilded Autocrat Evolved",
  "Hazhan, Demonblade Knight Evolved",
  "Wretch Evolved",
  "Redcap Evolved",
  "Phantom Blaster Dragon Evolved",
  "Blaster Dark Evolved",
  "VI. Milteo, The Lovers Evolved",
  "Sincere Masquerade Ghost ADVANCED",
  "Deathbringer Evolved",
  "Ghost Maid Evolved",
  "Moonrise Werewolf Evolved",
  "Vania, Kind Queen",
  "Oldblood King Evolved",
  "Big Soul Hunter Evolved",
  "Orator of the Bones Evolved",
  "Crimson Rose Queen Evolved",
  "Tartarus, the Tormentor Evolved",
  "Chris Pumpkinhead Evolved",
  "Marian the Mummy Evolved",
  "Mono, Garnet Rebel Evolved",
  "Doublame, Duke and Dame Evolved",
  "Nicola, Forbidden Strength Evolved",
  "Berserk Demon Evolved",
  "Yukimi Sajo Evolved",
  "Ranko Kanzaki Evolved",
  "Takumi Mukai Evolved",
  "Aki Yamato Evolved",
  "Syoko Hoshi Evolved",
  "Ginsetsu, Great Fox Evolved",
  "Shuten-Doji Evolved",
  "Cougar Pelt Warrior Evolved",
  "Zashiki-Warashi Evolved",
  "Rulenye, Omen of Silence Evolved",
  "Apostle of Silence Evolved",
  "Masked Puppet Evolved",
  "Servant of Lust Evolved",
  "Howling Demon Evolved",
  "Stheno Evolved",
  "Fenrir Evolved",
  "Frogbat Evolved",
  "Masquerade Ghost Evolved",
  "Baccherus, Peppy Ghostie Evolved",
  "Trombone Devil Evolved",
  "Mischievous Zombie Evolved",
  "Maruzensky Evolved",
  "Soul Dealer Evolved",
  "Azazel Evolved",
  "Veight, Vampire Noble Evolved",
  "Demonic Hedonist Evolved",
  "Playful Necromancer Evolved",
  "Lesser Mummy Evolved",
  "Lilith Evolved",
  "Cerberus Evolved",
  "Righteous Devil Evolved",
  "Crazed Executioner Evolved",
  "Wardrobe Raider Evolved",
  "Urias, Final Vampire Evolved",
  "Aenea, Creative Amethyst Evolved",
  "Amy, Psychopomp Guide Evolved",
  "Rouge Vampire Evolved",
  "Nono Morikubo [individuals] Evolved",
  "Chitose Kurosaki [Memento Mori] Evolved",
  "Natsuki Kimura [Scarlet Love Song] Evolved",
  "Spawn of the Abyss Evolved",
  "Ilze & Urze, Centennial Reapers Evolved",
  "Vania, Crimson Majesty Evolved",
  "Covetous Serpent Evolved",
  "Exhumation Crow Evolved",
  "Gnawing Rat Evolved",
  "Beryl, Dreameater Evolved",

  "Illya Evolved",
  "Shinobu Evolved",
  "Yori Evolved",
  "Misaki Evolved",

  "Garodeth, Insurgent Convict Evolved",
  "Abyssal Colonel Evolved",
  "Underworld Lieutenant Evolved",
  "Vicious Blitzer Evolved",

  "Rulenye & Valnareik Evolved",
  "Sham-Nacha, Heir to Entwining Evolved",
  "Congregant of Entwining Evolved",
  "Spirited Gravekeeper Evolved",
  "Ephemeral Demon Princess Evolved",

  "Cornelius, the Corpse King Evolved",
  "Arka, Sin Spinner Evolved",
  "Mach-Speed Maron Evolved",
  "Bonebreaker Bladesman Evolved",

  "Dark Emperor Evolved",
  "Suzy, Hexcaster Evolved",
  "Scarlet Vampire Evolved",
  "Thunderbolt Fiend Evolved",
];

export const havenEvo = [
  "Ceryneian Lighthind Evolved",
  "SugarSugar☆Mi〜n Evolved",
  "Rodeo, Anathema of Judgment Evolved",
  "Ronavero, Darkhaven Ward Evolved",
  "Angelic Prism Priestess Evolved",
  "Ironfist Priest Evolved",
  "Marwynn, Repose of Despair Evolved",
  "Shiro, Cursed Wings Evolved",
  "Adherent of Despair Evolved",
  "Temple Healer Evolved",
  "All-Feeling Divine Evolved",
  "Nekhbet Evolved",
  "Winged Gatekeeper Evolved",
  "Twinblade Featherfolk Evolved",
  "Satono Crown Evolved",
  "Jeanne, Despair's Maiden Evolved",
  "Lunerian Paladin Evolved",
  "Pyne, Twisted Justice Evolved",
  "Charitable Al-mi'raj Evolved",
  "Rola, Inferno Dragoon Evolved",
  "Gullias, Silverbeast Lord Evolved",
  "Holylight Convert Evolved",
  "Sol Sister Evolved",
  "Anvelt, Judgment's Cannon Evolved",
  "Vengeful Sniper Evolved",
  "Set Evolved",
  "Enchanted Knight Evolved",
  "CEO Amaterasu Evolved",
  "Silent Tom Evolved",
  "VIII. Sofina, Strength Evolved",
  "Reverend Adjudicator Evolved",
  "Topaz Swordian Evolved",
  "Priestess of Foresight Evolved",
  "Jeanne, Beacon of Salvation Evolved",
  "Ceryneian Lighthind",
  "Jeweled Priestess Evolved",
  "Lycaon Evolved",
  "Godsworn Alexiel Evolved",
  "Eidolon of Madness Evolved",
  "Collete, Holy Gunner Evolved",
  "Temple Windbear Evolved",
  "Limonia, Flawed Saint Evolved",
  "Marione, Light of Balance Evolved",
  "Robofalcon Evolved",
  "Dark Bishop Evolved",
  "Kako Takafuji Evolved",
  "Shin Sato Evolved",
  "Nana Abe Evolved",
  "Haru Yuuki Evolved",
  "Layla Evolved",
  "Karula, Arts Master Evolved",
  "Phantom Blade Wielder Evolved",
  "Holy Lancer Evolved",
  "Barrage Brawler Evolved",
  "Marwynn, Omen of Repose Evolved",
  "Apostle of Repose Evolved",
  "Unidentified Subject Evolved",
  "Demon's Epitaph Evolved",
  "Dark Jeanne Evolved",
  "Zoe, Princess of Goldenia Evolved",
  "Star Priestess Evolved",
  "Mist Shaman Evolved",
  "Diamond Master Evolved",
  "Wingy Chirpy Gemstone Evolved",
  "Ruby Falcon Evolved",
  "Pinion Prince Evolved",
  "Mejiro McQueen Evolved",
  "Heavenly Aegis Evolved",
  "Kaguya Evolved",
  "Radiance Angel Evolved",
  "Soul Collector Evolved",
  "Priest of the Cudgel Evolved",
  "Ardent Nun Evolved",
  "Guardian Nun Evolved",
  "Jeanne d'Arc Evolved",
  "Arch Priestess Laelia Evolved",
  "Prism Priestess Evolved",
  "Mainyu Evolved",
  "Yuwan, Dimensional Avenger Evolved",
  "Marlone, Peace Advocate Evolved",
  "Aerial Craft Evolved",
  "Steelwing Evolved",
  "Relic Goddess ADVANCED",
  "Nana Abe [Cinderella Girl] Evolved",
  "Kako Takafuji [Lady Luck] Evolved",
  "Kotoka Saionji [Pure Euphoria] Evolved",
  "Colette, Holy Gunner Evolved",
  "Wingy, Chirpy Gemstone Evolved",
  "Marlone, Light of Balance Evolved",
  "Seishiro, Admonishing Faith Evolved",
  "Conferrer of Vows Evolved",
  "Deliverer of Punishment Evolved",
  "Lorena, Iron-Willed Priest Evolved",
  "Votary of Contemplation Evolved",

  "Saren Evolved",
  "Yui Evolved",
  "Chika Evolved",
  "Mimi Evolved",

  "Uneriel, Winged Enforcer Evolved",
  "Warden of the Wings Evolved",
  "Agent of the Commandments Evolved",
  "Sacred Tiger Evolved",

  "Himeka, Heir to Repose Evolved",
  "Congregant of Repose Evolved",
  "Supplicant of Repose Evolved",
  "Knight of the Holy Order Evolved",

  "Verdilia, Rogue Professor Evolved",
  "Wilbert, Desolate Paladin Evolved",
  "Lou, Lady-in-Training Evolved",
  "Pureflame Lady Evolved",
  "Zlatorog Evolved",

  "Akino & Saren Evolved",

  "Holy Saber Evolved",
  "Sacred Lion Evolved",
  "Carmia, Miracle Optimist Evolved",
  "Holy Kitty Evolved",
];

export const neutralEvo = [
  "A Super Successful Event! Evolved",
  "At the End of the Day Evolved",
  "Forth! Into the Great Age of Agriculture! Evolved",
  "Harbinger of the Night Evolved",
  "Hungry for a Miracle Evolved",
  "Workshop! Farmers for a Day! Evolved",
  "Olivia, Heroic Dark Angel Evolved",
  "Phildau, Lionheart Ward Evolved",
  "Apollo, Heaven's Envoy Evolved",
  "Gilnelise, Ravenous Craving Evolved",
  "Arael Evolved",
  "Mechanical Analyzer Evolved",
  "Nomadic Conductor Evolved",
  "Magna Saber Evolved",
  "Glistering Angel Evolved",
  "Gunslinger Automaton Evolved",
  "Brave Goblin Evolved",
  "Sahaquiel & Israfil Evolved",
  "Miriam, Mutinous Being Evolved",
  "Managrocer Evolved",
  "Armored Goblin Evolved",
  "Changewing Cherub Evolved",
  "Romantic Chanteuse Evolved",
  "Plucky Treasure Hunter Evolved",
  "Sylvia, Grand Arbiter Evolved",
  "Quixotic Adventurer Evolved",
  "Wandering Chef Evolved",
  "Rivaylian Bandit Evolved",
  "Drive Point",
  "XXI. Zelgenea, O Great World ADVANCED",
  "Starbright Deity Evolved",
  "One-Winged Traitor Evolved",
  "Pureshot Angel Evolved",
  "Marduk Evolved",
  "Paradise Vanguard Evolved",
  "Suttungr Evolved",
  "Valkyrie of Chaos Evolved",
  "Alterplane Arbiter Evolved",
  "Sahaquiel Evolved",
  "Reina, Evolution's Herald Evolved",
  "High Enchantress Evolved",
  "Viridia Magna Evolved",
  "Maisha, Hero of Purgation Evolved",
  "Robogoblin Evolved",
  "Aldis, Trendsetting Seraph Evolved",
  "Badb Catha Evolved",
  "Mithra, Daybreak Diety Evolved",
  "Chaht, Ringside Announcer Evolved",
  "Bazooka Goblins Evolved",
  "Mjerrabaine, Omen of One Evolved",
  "Apostle of Craving Evolved",
  "Rosa, Mech Wing Maiden Evolved",
  "Cat Cannoneer Evolved",
  "Israfil Evolved",
  "Grimnir, War Cyclone Evolved",
  "Goblin Princess Evolved",
  "Owlcat Evolved",
  "Alice, Wonderland Explorer Evolved",
  "Garuel, Seraphic Leo Evolved",
  "Humpty Dumpty Evolved",
  "Harbringer of the Night Evolved",
  "Carrot",
  "Bahamut Evolved",
  "Archangel Reina Evolved",
  "Unicorn Dancer Unicorn Evolved",
  "Sektor Evolved",
  "Lucifer Evolved",
  "Urd Evolved",
  "Bellringer Angel Evolved",
  "Goblinmount Demon Evolved",
  "Goblin Evolved",
  "Goliath Evolved",
  "Healing Angel Evolved",
  "Maisha, Purgation's Vessel Evolved",
  "Hoverboard Mercenary Evolved",
  "Mithra, Daybreak Deity Evolved",
  "Unicorn Dancer Unica Evolved",
  "Saito, Mao Ward Officer Evolved",
  "Stunfist Assassin Evolved",
  "Cyberglasses Criminal Evolved",

  "Omniscient Kaiser Evolved",
  "Ameth Evolved",
  "Kasumi Evolved",

  "Cutthroat, Discord Convict Evolved",
  "Zerael, Regent of Vicissitude ADVANCED",
  "Smeltwork Bodyguard Evolved",

  "Mjerrabaine, Great Manifest Evolved",
  "Dogged One Evolved",
  "Apostle of Voracity Evolved",

  "Princess Knight Evolved",

  "Lucius, Travelled Trainer Evolved",

  "Goblin Leader Evolved",
];

export const set17Evo = [
  "Ladica, Verdant Claw Evolved",
  "Lococo, Little Puppeteer Evolved",
  "Beastfolk Harvester Evolved",
  "Blossom Treant Evolved",
  "Mistolina & Bayleon Evolved",
  "Frenzied Corpsmaster Evolved",
  "Valhorean Dealer Evolved",
  "Fox Lancer Evolved",
  "Isabelle, Intrepid Mage Evolved",
  "Tetra, Serene Sapphire Evolved",
  "Marie, Flowery Magician Evolved",
  "Awakened Robot Evolved",
  "Disrestan, Ocean Harbinger Evolved",
  "Djeana, the Stouthearted Evolved",
  "Forestclaw Sentinel Evolved",
  "Shark Warrior Evolved",
  "Urias, Final Vampire Evolved",
  "Aenea, Creative Amethyst Evolved",
  "Amy, Psychopomp Guide Evolved",
  "Rouge Vampire Evolved",
  "Yuwan, Dimensional Avenger Evolved",
  "Marlone, Peace Advocate Evolved",
  "Aerial Craft Evolved",
  "Steelwing Evolved",
  "Maisha, Purgation's Vessel Evolved",
  "Hoverboard Mercenary Evolved",
  "Relic Goddess ADVANCED",
];

export const setIDOL2Evo = [
  "Anastasia [Seize the Light] Evolved",
  "Riina Tada [Wannabe Legend] Evolved",
  "Hinako Kita [True Dream] Evolved",
  "Mio Honda [Cinderella Girl] Evolved",
  "Airi Totoki [Cinderella Girl] Evolved",
  "Mayu Sakuma [Love-Laden Gift] Evolved",
  "Chieri Ogata [Happiness Tune] Evolved",
  "Sae Kobayakawa [Dancing Flowers] Evolved",
  "Hiromi Seki [Twinkle in My Eye] Evolved",
  "Fumika Sagisawa [Cinderella Girl] Evolved",
  "Yui Ohtsuki [Lollipop Darling] Evolved",
  "Hotaru Shiragiku [Unbreakable] Evolved",
  "Nono Morikubo [individuals] Evolved",
  "Chitose Kurosaki [Memento Mori] Evolved",
  "Natsuki Kimura [Scarlet Love Song] Evolved",
  "Nana Abe [Cinderella Girl] Evolved",
  "Kako Takafuji [Lady Luck] Evolved",
  "Kotoka Saionji [Pure Euphoria] Evolved",
];

export const setSD01Evo = [
  "Rose Gardener Evolved",
  "Treant Evolved",
  "Water Fairy Evolved",
  "Goblin Evolved",
];

export const setPREvo = [
  "Elven Princess Mage Evolved",
  "Floral Fencer Evolved",
  "Dragon Warrior Evolved",
  "Lilith Evolved",
  "Priest of the Cudgel Evolved",
  "Crystalia Tia Evolved",
  "Carrot",
  "Oathless Knight Evolved",
  "Dragon Summoner Evolved",
  "Dragontamer Evolved",
  "Penguin Wizard Evolved",
  "Tweedle Dum, Tweedle Dee Evolved",
  "Wingy, Chirpy Gemstone Evolved",
  "Star Phoenix Evolved",
  "Zoe, Princess of Goldenia Evolved",
  "Draconir, Knuckle Dragon Evolved",
  "King Elephant Evolved",
  "Avant Blader Evolved",
  "Azazel Evolved",
  "Sahaquiel Evolved",
  "Setus, the Beastblade Evolved",
  "Leod, the Crescent Blade Evolved",
  "Eleanor, Cosmic Flower Evolved",
  "Marion, Elegant Dragonewt Evolved",
  "Doublame, Duke and Dame Evolved",
  "Marlone, Light of Balance Evolved",
  "Maisha, Hero of Purgation Evolved",
  "Spawn of the Abyss Evolved",
  "Valkyrie of Chaos Evolved",
  "Rabbit Mage Evolved",
  "Paradise Vanguard Evolved",
  "Blue Storm Supreme Dragon, Glory Maelstrom Evolved",
  "Colette, Holy Gunner Evolved",
  "Crystalia Lily Evolved",
  "XXI. Zelgenea, O Great World ADVANCED",
  "Hazhan, Demonblade Knight Evolved",
  "Quixotic Adventurer Evolved",
  "Dragonic Overlord Evolved",
  "Oldblood King Evolved",
  "Reinhardt, the Deathless Evolved",
  "Prudent General Evolved",
  "Deathbringer Evolved",
  "Merlin Evolved",
  "Fairy Slugger Evolved",
  "Changewing Cherub Evolved",
  "Piercye, Queen of Frost Evolved",
  "Hozumi, Enchanting Hostess Evolved",
  "Phildau, Lionheart Ward Evolved",
  "Lunerian Paladin Evolved",
  "Acid Golem Evolved",
  "Aerin, Crystalian Frostward Evolved",
  "Amy, Psychopomp Guide Evolved",
  "Blaster Blade Evolved",
];

export const setSS02Evo = [
  "Dragon Warrior Evolved",
  "Roc Evolved",
  "Dragonrider Evolved",
  "Goliath Evolved",
];

export const setSS01Evo = [
  "Floral Fencer Evolved",
  "Oathless Knight Evolved",
  "Quickblader Evolved",
  "Goblin Evolved",
];

export const setGFB01Evo = [
  "Albert, Levin Saber Evolved",
  "Leonidas Evolved",
  "Wingy, Chirpy Gemstone Evolved",
  "Archangel Reina Evolved",
  "Floral Fencer Evolved",
  "Maid Leader Evolved",
  "Unicorn Dancer Unica Evolved",
  "Rosa, Mech Wing Maiden Evolved",
  "Archer Evolved",
  "Fita the Gentle Elf Evolved",
  "Quickblader Evolved",
  "Bladed Hedgehog Evolved",
  "Tristan of the Round Table Evolved",
  "Craig, Wizard of Mysteria Evolved",
  "Demon's Epitaph Evolved",
  "Deepwood Anomaly Evolved",
  "Wordwielder Ginger Evolved",
  "Bahamut Evolved",
  "Barbarossa Evolved",
  "Geno, Machine Artisan Evolved",
  "Demonflame Mage Evolved",
  "Cetus Evolved",
  "Prism Priestess Evolved",
  "Goblinmount Demon Evolved",
  "Hippocampus Evolved",
  "Mist Shaman Evolved",
  "Spawn of the Abyss Evolved",
  "Merlin Evolved",
  "Cerberus Evolved",
  "Israfil Evolved",
  "Azazel Evolved",
  "Zoe, Princess of Goldenia Evolved",
  "Bellringer Angel Evolved",
  "Shenlong Evolved",
  "Penguin Wizard Evolved",
  "Imperial Dragoon Evolved",
  "Jeanne d'Arc Evolved",
  "Heavenly Aegis Evolved",
  "Lucifer Evolved",
  "Apostle of Repose Evolved",
  "Iron Staff Mechanic Evolved",
  "Priest of the Cudgel Evolved",
  "Radiance Angel Evolved",
];

export const setGFD02Evo = [
  "Sweet-Tooth Medusa Evolved",
  "Azi Dahaka Evolved",
  "Karula, Arts Master Evolved",
  "Badb Catha Evolved",
  "Bellringer Angel Evolved",
  "Mithra, Daybreak Deity Evolved",
  "Maid Leader Evolved",
  "Roy, Dragoncleaver Evolved",
  "Shenlong Evolved",
  "Colette, Holy Gunner Evolved",
  "Fita the Gentle Elf Evolved",
  "Witch of Sweets Evolved",
  "Geovore Evolved",
  "Frogbat Evolved",
];

export const setGFD01Evo = [
  "Ancient Elf Evolved",
  "Cosmos Fang Evolved",
  "Lucifer Evolved",
  "Rhinoceroach Evolved",
  "Slade, Blossoming Wolf Evolved",
  "Setus, the Beastblade Evolved",
  "Elven Princess Mage Evolved",
  "Gerbera Bear Evolved",
  "Michelle, the Mind Reader Evolved",
  "Maid Leader Evolved",
  "Prism Priestess Evolved",
  "Rosa, Mech Wing Maiden Evolved",
  "Tweedle Dum, Tweedle Dee Evolved",
  "Craig, Wizard of Mysteria Evolved",
];

export const setSDD06Evo = [
  "Godsworn Alexiel Evolved",
  "Prism Priestess Evolved",
  "XXI. Zelgenea, O Great World ADVANCED",
  "Paradise Vanguard Evolved",
];

export const setSDD05Evo = [
  "VI. Milteo, The Lovers Evolved",
  "Iceschillendrig, Gilded Autocrat Evolved",
  "Doublame, Duke and Dame Evolved",
  "Wretch Evolved",
  "Wandering Chef Evolved",
];

export const setSDD04Evo = [
  "XI. Erntz, Justice Evolved",
  "Frostbite Dragon Evolved",
  "Roy, Dragoncleaver Evolved",
  "Azureflame Dragonewt Evolved",
];

export const setSDD03Evo = [
  "Sweet-Tooth Medusa Evolved",
  "Ceridwen, Eternity Hunter Evolved",
  "Ancient Alchemist Evolved",
  "Acid Golem Evolved",
  "Artistic Arcanist Evolved",
  "Rabbit Mage Evolved",
];

export const setSDD02Evo = [
  "Ralmia, Sonic Racer Evolved",
  "Bunny & Baron, Specter Duo Evolved",
  "Leod, the Crescent Blade Evolved",
  "Prudent General Evolved",
  "Quixotic Adventurer Evolved",
  "Rivaylian Bandit Evolved",
];

export const setSDD01Evo = [
  "Aria, Miasma Fairy Evolved",
  "Sukuna, Brave and Small Evolved",
  "Sunbright Elf Evolved",
  "Fairy Slugger Evolved",
];

export const setSD06Evo = [
  "Priest of the Cudgel Evolved",
  "Ardent Nun Evolved",
  "Guardian Nun Evolved",
  "Healing Angel Evolved",
];

export const setSD05Evo = [
  "Playful Necromancer Evolved",
  "Lesser Mummy Evolved",
  "Lilith Evolved",
  "Goliath Evolved",
];

export const setSD04Evo = [
  "Dragon Warrior Evolved",
  "Roc Evolved",
  "Dragonrider Evolved",
  "Goliath Evolved",
];

export const setSD03Evo = [
  "Demonflame Mage Evolved",
  "Penguin Wizard Evolved",
  "Sammy, Wizard's Apprentice Evolved",
  "Healing Angel Evolved",
];

export const setSD02Evo = [
  "Floral Fencer Evolved",
  "Oathless Knight Evolved",
  "Quickblader Evolved",
  "Goblin Evolved",
];

export const set18Evo = [
  "Rolo Rone, Verdant Purifier Evolved",
  "Verdant Authority Caretaker Evolved",
  "Verdant City Pugilist Evolved",
  "Blossoming Lunerian Evolved",
  "Verdant Law Supplicant Evolved",
  "Shinra, All-Discerning Evolved",
  "Bird's-Eye Investigator Evolved",
  "Cold Case Analyst Evolved",
  "Blind Spot Surveyor Evolved",
  "Monika, Cloudhall Admiral Evolved",
  "Mana, Sterling Luster Evolved",
  "Bejeweled Supermodel Evolved",
  "Bejeweled Advisor Evolved",
  "Bejeweled Bouncer Evolved",
  "Carbuncle of Mysteria Evolved",
  "El, Destructive Dragon Evolved",
  "Dragon-Eyed Secretary Evolved",
  "Neon-Tailed Prefect Evolved",
  "Ian, Dragon Buster Evolved",
  "Lightning-Clawed Loafer Evolved",
  "Ilze & Urze, Centennial Reapers Evolved",
  "Vania, Crimson Majesty Evolved",
  "Covetous Serpent Evolved",
  "Exhumation Crow Evolved",
  "Gnawing Rat Evolved",
  "Beryl, Dreameater Evolved",
  "Seishiro, Admonishing Faith Evolved",
  "Conferrer of Vows Evolved",
  "Deliverer of Punishment Evolved",
  "Lorena, Iron-Willed Priest Evolved",
  "Votary of Contemplation Evolved",
  "Saito, Mao Ward Officer Evolved",
  "Stunfist Assassin Evolved",
  "Cyberglasses Criminal Evolved",
];

export const set20Evo = [
  "Krulle, Heir to Unkilling Evolved",
  "Windbloom Sylph Evolved",
  "Supplicant of Unkilling Evolved",
  "Bearer of the Fairy Blade Evolved",
  "Sinciro, Heir to Usurpation Evolved",
  "Congregant of Usurpation Evolved",
  "Peppy Scout Evolved",
  "Comrade of the Swordmaster Evolved",
  "Velharia, Heir to Truth Evolved",
  "Axia, Heir to Destruction Evolved",
  "Raio, Elimination Manifest Evolved",
  "Congregant of Truth Evolved",
  "Devotee of Destruction Evolved",
  "Azurifrit, Heir to Disdain Evolved",
  "Spoiled Mermanager Evolved",
  "Supplicant of Disdain Evolved",
  "Snowstorm Dragonewt Evolved",
  "Rulenye & Valnareik Evolved",
  "Sham-Nacha, Heir to Entwining Evolved",
  "Congregant of Entwining Evolved",
  "Spirited Gravekeeper Evolved",
  "Ephemeral Demon Princess Evolved",
  "Himeka, Heir to Repose Evolved",
  "Congregant of Repose Evolved",
  "Supplicant of Repose Evolved",
  "Knight of the Holy Order Evolved",
  "Mjerrabaine, Great Manifest Evolved",
  "Dogged One Evolved",
  "Apostle of Voracity Evolved",
];

export const set19Evo = [
  "Magachiyo, Barbed Convict Evolved",
  "Verdant Lieutenant Evolved",
  "Budding Initiate Evolved",
  "Beast Lancer Evolved",
  "Barbaros, Briny Convict Evolved",
  "Gildaria, Anathema of Peace Evolved",
  "Warden of Honor Evolved",
  "Storm-Wracked First Mate Evolved",
  "Felpurr Maid Evolved",
  "Sephie, Depraved Convict Evolved",
  "Obsessive Scholar Evolved",
  "Devoted Researcher Evolved",
  "Electrokitty Evolved",
  "Drazael, Ravening Enforcer Evolved",
  "Scorched-Earth Tyrant Evolved",
  "Hotheaded Marauder Evolved",
  "Dancing Crab Evolved",
  "Garodeth, Insurgent Convict Evolved",
  "Abyssal Colonel Evolved",
  "Underworld Lieutenant Evolved",
  "Vicious Blitzer Evolved",
  "Uneriel, Winged Enforcer Evolved",
  "Warden of the Wings Evolved",
  "Agent of the Commandments Evolved",
  "Sacred Tiger Evolved",
  "Cutthroat, Discord Convict Evolved",
  "Zerael, Regent of Vicissitude ADVANCED",
  "Smeltwork Bodyguard Evolved",
];

export const set04Evo = [
  "Kokkoro Evolved",
  "Shiori Evolved",
  "Rino Evolved",
  "Lima Evolved",
  "Pecorine Evolved",
  "Jun Evolved",
  "Tomo Evolved",
  "Tamaki Evolved",
  "Karyl Evolved",
  "Maho Evolved",
  "Kyoka Evolved",
  "Yuki Evolved",
  "Sheffy Evolved",
  "Kaya Evolved",
  "Inori Evolved",
  "Mifuyu Evolved",
  "Illya Evolved",
  "Shinobu Evolved",
  "Yori Evolved",
  "Misaki Evolved",
  "Saren Evolved",
  "Yui Evolved",
  "Chika Evolved",
  "Mimi Evolved",
  "Omniscient Kaiser Evolved",
  "Ameth Evolved",
  "Kasumi Evolved",
];

export const set01Evo = [
  "Grea, Mysterian Dragoness Evolved",
  "Mysteria, Magic Founder Evolved",
  "Vayle, Mysterian Summoner Evolved",
  "Craig, Wizard of Mysteria Evolved",
];

export const set21Evo = [
  "Lyelth, Immaculate Idol Evolved",
  "Cleaver Cat Evolved",
  "Elven Farmhand Evolved",
  "Bladebunny Evolved",
  "Galdr, Heroic Headmaster Evolved",
  "Agile Twinblader Evolved",
  "Tony, Plucky Polliwog Evolved",
  "Kitty Sergeant Evolved",
  "Anne, Brilliant Mage Evolved",
  "Grea, Crimson Promise Evolved",
  "Gruinne, Leonardian Provost Evolved",
  "Wolf Whisperer Evolved",
  "Lilium, the Witchwyrm Evolved",
  "Grand Slam Tamer Evolved",
  "Dragonborn Striker Evolved",
  "Ipupiara Evolved",
  "Cornelius, the Corpse King Evolved",
  "Arka, Sin Spinner Evolved",
  "Mach-Speed Maron Evolved",
  "Bonebreaker Bladesman Evolved",
  "Verdilia, Rogue Professor Evolved",
  "Wilbert, Desolate Paladin Evolved",
  "Lou, Lady-in-Training Evolved",
  "Pureflame Lady Evolved",
  "Zlatorog Evolved",
  "Lucius, Travelled Trainer Evolved",
];

export const set03Evo = [
  "Iceschillendrig, Gilded Autocrat Evolved",
  "Wretch Evolved",
  "Wandering Chef Evolved",
  "Adherent of Screams Evolved",
];

export const set02Evo = [
  "Merlin Evolved",
  "Grimoire Sorcerer Evolved",
  "Chaos Wielder Evolved",
  "Crystal Fencer Evolved",
];

export const set08Evo = [
  "XI. Erntz, Justice Evolved",
  "Liu Feng, Goldennote Ward Evolved",
  "Azureflame Dragonewt Evolved",
  "Roy, Dragoncleaver Evolved",
];

export const set07Evo = [
  "Albert, Thunderous Doom Evolved",
  "Albert, Levin Saber Evolved",
  "Zirconia, Ironcrown Ward Evolved",
  "Lounes, Levin Apprentice Evolved",
  "Mina, Levin Vice Leader Evolved",
];

export const set22Evo = [
  "Aerin, Forever Brilliant Evolved",
  "Flower Fox Evolved",
  "Wellspring Elf Princess Evolved",
  "Coldhearted Dark Elf Evolved",
  "Armelize, Opulent Strategist Evolved",
  "Assault Knight Evolved",
  "Axe Pirate Evolved",
  "Calculating Captain Evolved",
  "Chrono Witch Evolved",
  "Levi, Wizard of Ages Evolved",
  "Witching Moggy Evolved",
  "Elina, Winged Evangelist Evolved",
  "Blade Mage Evolved",
  "Ignis Dragon Evolved",
  "Noir & Blanc, Brothers Evolved",
  "Coral Spirit Evolved",
  "Hailwyrm Evolved",
  "Dark Emperor Evolved",
  "Suzy, Hexcaster Evolved",
  "Scarlet Vampire Evolved",
  "Thunderbolt Fiend Evolved",
  "Holy Saber Evolved",
  "Sacred Lion Evolved",
  "Carmia, Miracle Optimist Evolved",
  "Holy Kitty Evolved",
  "Goblin Leader Evolved",
  "Oguri Cap [Surging Beast] Evolved",
];
